var items = {
  "block.minecraft.acacia_button": "Akatsienholtknop",
  "block.minecraft.acacia_door": "Akatsiendüör",
  "block.minecraft.acacia_fence": "Akatsienholttuun",
  "block.minecraft.acacia_fence_gate": "Akatsienholttuunpaort",
  "block.minecraft.acacia_hanging_sign": "Akaatzienboom Tau-Schild",
  "block.minecraft.acacia_leaves": "Akatsienbliäder",
  "block.minecraft.acacia_log": "Akatsienstam",
  "block.minecraft.acacia_planks": "Akacienholtbreden",
  "block.minecraft.acacia_pressure_plate": "Akatsienholtdrukplaat",
  "block.minecraft.acacia_sapling": "Akatsiensetter",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Akatsienholtschild",
  "block.minecraft.acacia_slab": "Akatsienholtplaat",
  "block.minecraft.acacia_stairs": "Akatsienholttrapp",
  "block.minecraft.acacia_trapdoor": "Akatsienholtluuk",
  "block.minecraft.acacia_wall_hanging_sign": "Akaatschiidwand Tau-Schild",
  "block.minecraft.acacia_wall_sign": "Akatsienholtmüerschild",
  "block.minecraft.acacia_wood": "Akatsienholt",
  "block.minecraft.activator_rail": "Ankriegschine",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Stäänlauk",
  "block.minecraft.amethyst_block": "Amethystblok",
  "block.minecraft.amethyst_cluster": "Amethystschoof",
  "block.minecraft.ancient_debris": "Antiker Schroot",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitplaat",
  "block.minecraft.andesite_stairs": "Andesittrapp",
  "block.minecraft.andesite_wall": "Andesitmüer",
  "block.minecraft.anvil": "Ambold",
  "block.minecraft.attached_melon_stem": "Meloonrank",
  "block.minecraft.attached_pumpkin_stem": "Käversrank",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlauv",
  "block.minecraft.azure_bluet": "Blao Porslainenstäänken",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambooblock",
  "block.minecraft.bamboo_button": "Bambusknopp",
  "block.minecraft.bamboo_door": "Bambusdöör",
  "block.minecraft.bamboo_fence": "Bambusfeuns",
  "block.minecraft.bamboo_fence_gate": "Bambusfeunstor",
  "block.minecraft.bamboo_hanging_sign": "Bamboohängschild",
  "block.minecraft.bamboo_mosaic": "Bamboomosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bamboomosaikplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaikholttrapp",
  "block.minecraft.bamboo_planks": "Bambusplanken",
  "block.minecraft.bamboo_pressure_plate": "Bambusdrukplaat",
  "block.minecraft.bamboo_sapling": "Bambusspröösling",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bambusschild",
  "block.minecraft.bamboo_slab": "Bambusstufe",
  "block.minecraft.bamboo_stairs": "Bambusholttrapp",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboo Wall Hanging Sign",
  "block.minecraft.bamboo_wall_sign": "Bamboo Wall Sign",
  "block.minecraft.banner.base.black": "Kumplett swates Feld",
  "block.minecraft.banner.base.blue": "Kumplett blaoes Feld",
  "block.minecraft.banner.base.brown": "Kumplett bruunes Feld",
  "block.minecraft.banner.base.cyan": "Kumplett blaogröönes Feld",
  "block.minecraft.banner.base.gray": "Kumplett graoes Feld",
  "block.minecraft.banner.base.green": "Kumplett gröönes Feld",
  "block.minecraft.banner.base.light_blue": "Kumplett lechtblaoes Feld",
  "block.minecraft.banner.base.light_gray": "Kumplett grieses Feld",
  "block.minecraft.banner.base.lime": "Kumplett lechtgröönes Feld",
  "block.minecraft.banner.base.magenta": "Kumplett magenta Feld",
  "block.minecraft.banner.base.orange": "Kumplett geelrootes Feld",
  "block.minecraft.banner.base.pink": "Kumplett fienrootes Feld",
  "block.minecraft.banner.base.purple": "Kumplett vigelettes Feld",
  "block.minecraft.banner.base.red": "Kumplett rootes Feld",
  "block.minecraft.banner.base.white": "Kumplett wittes Feld",
  "block.minecraft.banner.base.yellow": "Kumplett geeles Feld",
  "block.minecraft.banner.border.black": "Swatter Boord",
  "block.minecraft.banner.border.blue": "Blaoer Boord",
  "block.minecraft.banner.border.brown": "Bruuner Boord",
  "block.minecraft.banner.border.cyan": "Blaogrööner Boord",
  "block.minecraft.banner.border.gray": "Graoer Boord",
  "block.minecraft.banner.border.green": "Grööner Boord",
  "block.minecraft.banner.border.light_blue": "Lechtblaoer Boord",
  "block.minecraft.banner.border.light_gray": "Grieser Boord",
  "block.minecraft.banner.border.lime": "Lechtgrööner Boord",
  "block.minecraft.banner.border.magenta": "Magenta Boord",
  "block.minecraft.banner.border.orange": "Geelrooter Boord",
  "block.minecraft.banner.border.pink": "Fienrooter Boord",
  "block.minecraft.banner.border.purple": "Vigeletter Boord",
  "block.minecraft.banner.border.red": "Rooter Boord",
  "block.minecraft.banner.border.white": "Witter Boord",
  "block.minecraft.banner.border.yellow": "Geeler Boord",
  "block.minecraft.banner.bricks.black": "Feld swat smöögt",
  "block.minecraft.banner.bricks.blue": "Feld blao smöögt",
  "block.minecraft.banner.bricks.brown": "Feld bruun smöögt",
  "block.minecraft.banner.bricks.cyan": "Feld blaogröön smöögt",
  "block.minecraft.banner.bricks.gray": "Feld grao smöögt",
  "block.minecraft.banner.bricks.green": "Feld gröön smöögt",
  "block.minecraft.banner.bricks.light_blue": "Feld lechtblao smöögt",
  "block.minecraft.banner.bricks.light_gray": "Feld gries smöögt",
  "block.minecraft.banner.bricks.lime": "Feld lechtgröön smöögt",
  "block.minecraft.banner.bricks.magenta": "Feld magenta smöögt",
  "block.minecraft.banner.bricks.orange": "Feld geelroot smöögt",
  "block.minecraft.banner.bricks.pink": "Feld fienroot smöögt",
  "block.minecraft.banner.bricks.purple": "Feld vigelett smöögt",
  "block.minecraft.banner.bricks.red": "Feld root smöögt",
  "block.minecraft.banner.bricks.white": "Feld witt smöögt",
  "block.minecraft.banner.bricks.yellow": "Feld geel smöögt",
  "block.minecraft.banner.circle.black": "Swatte Kuogel",
  "block.minecraft.banner.circle.blue": "Blaoe Kuogel",
  "block.minecraft.banner.circle.brown": "Bruune Kuogel",
  "block.minecraft.banner.circle.cyan": "Blaogrööne Kuogel",
  "block.minecraft.banner.circle.gray": "Graoe Kuogel",
  "block.minecraft.banner.circle.green": "Grööne Kuogel",
  "block.minecraft.banner.circle.light_blue": "Lechtblaoe Kuogel",
  "block.minecraft.banner.circle.light_gray": "Griese Kuogel",
  "block.minecraft.banner.circle.lime": "Lechtgrööne Kuogel",
  "block.minecraft.banner.circle.magenta": "Magenta Kuogel",
  "block.minecraft.banner.circle.orange": "Geelroote Kuogel",
  "block.minecraft.banner.circle.pink": "Fienroote Kuogel",
  "block.minecraft.banner.circle.purple": "Vigelette Kuogel",
  "block.minecraft.banner.circle.red": "Roote Kuogel",
  "block.minecraft.banner.circle.white": "Witte Kuogel",
  "block.minecraft.banner.circle.yellow": "Geele Kuogel",
  "block.minecraft.banner.creeper.black": "Swatter Creeper",
  "block.minecraft.banner.creeper.blue": "Blaoer Creeper",
  "block.minecraft.banner.creeper.brown": "Bruuner Creeper",
  "block.minecraft.banner.creeper.cyan": "Blaogrööner Creeper",
  "block.minecraft.banner.creeper.gray": "Graoer Creeper",
  "block.minecraft.banner.creeper.green": "Grööner Creeper",
  "block.minecraft.banner.creeper.light_blue": "Lechtblaoer Creeper",
  "block.minecraft.banner.creeper.light_gray": "Grieser Creeper",
  "block.minecraft.banner.creeper.lime": "Lechtgrööner Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Geelrooter Creeper",
  "block.minecraft.banner.creeper.pink": "Fienrooter Creeper",
  "block.minecraft.banner.creeper.purple": "Vigeletter Creeper",
  "block.minecraft.banner.creeper.red": "Rooter Creeper",
  "block.minecraft.banner.creeper.white": "Witter Creeper",
  "block.minecraft.banner.creeper.yellow": "Geeler Creeper",
  "block.minecraft.banner.cross.black": "Swattes Andreaskrüüz",
  "block.minecraft.banner.cross.blue": "Blaoes Andreaskrüüz",
  "block.minecraft.banner.cross.brown": "Bruunes Andreaskrüüz",
  "block.minecraft.banner.cross.cyan": "Blaogröönes Andreaskrüüz",
  "block.minecraft.banner.cross.gray": "Graoes Andreaskrüüz",
  "block.minecraft.banner.cross.green": "Gröönes Andreaskrüüz",
  "block.minecraft.banner.cross.light_blue": "Lechtblaoes Andreaskrüüz",
  "block.minecraft.banner.cross.light_gray": "Grieses Andreaskrüüz",
  "block.minecraft.banner.cross.lime": "Lechtgröönes Andreaskrüüz",
  "block.minecraft.banner.cross.magenta": "Magenta Andreaskrüüz",
  "block.minecraft.banner.cross.orange": "Geelrootes Andreaskrüüz",
  "block.minecraft.banner.cross.pink": "Fienrootes Andreaskrüüz",
  "block.minecraft.banner.cross.purple": "Vigelettes Andreaskrüüz",
  "block.minecraft.banner.cross.red": "Rootes Andreaskrüüz",
  "block.minecraft.banner.cross.white": "Wittes Andreaskrüüz",
  "block.minecraft.banner.cross.yellow": "Geeles Andreaskrüüz",
  "block.minecraft.banner.curly_border.black": "Swatter Spickelboord",
  "block.minecraft.banner.curly_border.blue": "Blaoer Spickelboord",
  "block.minecraft.banner.curly_border.brown": "Bruuner Spickelboord",
  "block.minecraft.banner.curly_border.cyan": "Blaogrööner Spickelboord",
  "block.minecraft.banner.curly_border.gray": "Graoer Spickelboord",
  "block.minecraft.banner.curly_border.green": "Grööner Spickelboord",
  "block.minecraft.banner.curly_border.light_blue": "Lechtblaoer Spickelboord",
  "block.minecraft.banner.curly_border.light_gray": "Grieser Spickelboord",
  "block.minecraft.banner.curly_border.lime": "Lechtgrööner Spickelboord",
  "block.minecraft.banner.curly_border.magenta": "Magenta Spickelboord",
  "block.minecraft.banner.curly_border.orange": "Geelrooter Spickelboord",
  "block.minecraft.banner.curly_border.pink": "Fienrooter Spickelboord",
  "block.minecraft.banner.curly_border.purple": "Vigeletter Spickelboord",
  "block.minecraft.banner.curly_border.red": "Rooter Spickelboord",
  "block.minecraft.banner.curly_border.white": "Witter Spickelboord",
  "block.minecraft.banner.curly_border.yellow": "Geeler Spickelboord",
  "block.minecraft.banner.diagonal_left.black": "Swat schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.blue": "Blao schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.brown": "Bruun schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.cyan": "Blaogröön schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.gray": "Grao schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.green": "Gröön schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.light_blue": "Lechtblao schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.light_gray": "Gries schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.lime": "Lechtgröön schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.orange": "Geelroot schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.pink": "Fienroot schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.purple": "Vigelett schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.red": "Root schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.white": "Witt schreeglenks deelt",
  "block.minecraft.banner.diagonal_left.yellow": "Geel schreeglenks deelt",
  "block.minecraft.banner.diagonal_right.black": "Swat schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.brown": "Bruun schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.cyan": "Blaogröön schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.gray": "Grao schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.green": "Gröön schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.light_blue": "Lechtblao schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.light_gray": "Gries schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.lime": "Lechtgröön schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.orange": "Geelroot schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.pink": "Fienroot schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.purple": "Vigelett schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.red": "Root schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.white": "Witt schreegrächts deelt",
  "block.minecraft.banner.diagonal_right.yellow": "Geel schreegrächts deelt",
  "block.minecraft.banner.diagonal_up_left.black": "Swat schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruun schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Blaogröön schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grao schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Gröön schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lechtblao schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Gries schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Lechtgröön schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Geelroot schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Fienroot schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Vigelett schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Root schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Witt schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Geel schreegrächts deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Swat schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruun schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Blaogröön schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grao schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Gröön schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lechtblao schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Gries schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Lechtgröön schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Geelroot schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Fienroot schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Vigelett schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Root schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Witt schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geel schreeglenks deelt (Invertiert)",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Swatte Bloom",
  "block.minecraft.banner.flower.blue": "Blaoe Bloom",
  "block.minecraft.banner.flower.brown": "Bruune Bloom",
  "block.minecraft.banner.flower.cyan": "Blaogrööne Bloom",
  "block.minecraft.banner.flower.gray": "Graoe Bloom",
  "block.minecraft.banner.flower.green": "Grööne Bloom",
  "block.minecraft.banner.flower.light_blue": "Lechtblaoe Bloom",
  "block.minecraft.banner.flower.light_gray": "Griese Bloom",
  "block.minecraft.banner.flower.lime": "Lechtgrööne Bloom",
  "block.minecraft.banner.flower.magenta": "Magenta Bloom",
  "block.minecraft.banner.flower.orange": "Geelroote Bloom",
  "block.minecraft.banner.flower.pink": "Fienroote Bloom",
  "block.minecraft.banner.flower.purple": "Vigelette Bloom",
  "block.minecraft.banner.flower.red": "Roote Bloom",
  "block.minecraft.banner.flower.white": "Witte Bloom",
  "block.minecraft.banner.flower.yellow": "Geele Bloom",
  "block.minecraft.banner.globe.black": "Swarte Eer",
  "block.minecraft.banner.globe.blue": "Blaoe Eer",
  "block.minecraft.banner.globe.brown": "Brunne Eer",
  "block.minecraft.banner.globe.cyan": "Blaogrööne Eer",
  "block.minecraft.banner.globe.gray": "Graoe Eer",
  "block.minecraft.banner.globe.green": "Grööne Eer",
  "block.minecraft.banner.globe.light_blue": "Lechtblaoe Eer",
  "block.minecraft.banner.globe.light_gray": "Griese Eer",
  "block.minecraft.banner.globe.lime": "Lechtgrööne Eer",
  "block.minecraft.banner.globe.magenta": "Magenta Eer",
  "block.minecraft.banner.globe.orange": "Geelroote Eer",
  "block.minecraft.banner.globe.pink": "Fienroote Eer",
  "block.minecraft.banner.globe.purple": "Vigelette Eer",
  "block.minecraft.banner.globe.red": "Roote Eer",
  "block.minecraft.banner.globe.white": "Witte Eer",
  "block.minecraft.banner.globe.yellow": "Geele Eer",
  "block.minecraft.banner.gradient.black": "Swatter Farvverloop",
  "block.minecraft.banner.gradient.blue": "Blaoer Farvverloop",
  "block.minecraft.banner.gradient.brown": "Bruuner Farvverloop",
  "block.minecraft.banner.gradient.cyan": "Blaogrööner Farvverloop",
  "block.minecraft.banner.gradient.gray": "Graoer Farvverloop",
  "block.minecraft.banner.gradient.green": "Grööner Farvverloop",
  "block.minecraft.banner.gradient.light_blue": "Lechtblaoer Farvverloop",
  "block.minecraft.banner.gradient.light_gray": "Grieser Farvverloop",
  "block.minecraft.banner.gradient.lime": "Lechtgrööner Farvverloop",
  "block.minecraft.banner.gradient.magenta": "Magenta Farvverloop",
  "block.minecraft.banner.gradient.orange": "Geelrooter Farvverloop",
  "block.minecraft.banner.gradient.pink": "Fienrooter Farvverloop",
  "block.minecraft.banner.gradient.purple": "Vigeletter Farvverloop",
  "block.minecraft.banner.gradient.red": "Rooter Farvverloop",
  "block.minecraft.banner.gradient.white": "Witter Farvverloop",
  "block.minecraft.banner.gradient.yellow": "Geeler Farvverloop",
  "block.minecraft.banner.gradient_up.black": "Swatter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blaoer Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Bruuner Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Blaogrööner Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Graoer Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.green": "Grööner Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Lechtblaoer Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Grieser Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Lechtgrööner Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Geelrooter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Fienrooter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Vigeletter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.red": "Rooter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.white": "Witter Farvverloop (Invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Geeler Farvverloop (Invertiert)",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blaue Guster",
  "block.minecraft.banner.guster.brown": "Bruun Guster",
  "block.minecraft.banner.guster.cyan": "Blaugrön Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Owen swat deelt",
  "block.minecraft.banner.half_horizontal.blue": "Owen blao deelt",
  "block.minecraft.banner.half_horizontal.brown": "Owen bruun deelt",
  "block.minecraft.banner.half_horizontal.cyan": "Owen blaogröön deelt",
  "block.minecraft.banner.half_horizontal.gray": "Owen grao deelt",
  "block.minecraft.banner.half_horizontal.green": "Owen gröön deelt",
  "block.minecraft.banner.half_horizontal.light_blue": "Owen lechtblao deelt",
  "block.minecraft.banner.half_horizontal.light_gray": "Owen gries deelt",
  "block.minecraft.banner.half_horizontal.lime": "Owen lechtgröön deelt",
  "block.minecraft.banner.half_horizontal.magenta": "Owen magenta deelt",
  "block.minecraft.banner.half_horizontal.orange": "Owen geelroot deelt",
  "block.minecraft.banner.half_horizontal.pink": "Owen fienroot deelt",
  "block.minecraft.banner.half_horizontal.purple": "Owen vigelett deelt",
  "block.minecraft.banner.half_horizontal.red": "Owen root deelt",
  "block.minecraft.banner.half_horizontal.white": "Owen witt deelt",
  "block.minecraft.banner.half_horizontal.yellow": "Owen geel deelt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Ünnen swat deelt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Ünnen blao deelt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Ünnen bruun deelt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ünnen blaogröön deelt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Ünnen grao deelt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Ünnen gröön deelt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ünnen lechtblao deelt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ünnen gries deelt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Ünnen lechtgröön deelt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Ünnen magenta deelt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Ünnen geelroot deelt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ünnen fienroot deelt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Ünnen vigelett deelt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Ünnen root deelt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ünnen witt deelt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Ünnen geel deelt",
  "block.minecraft.banner.half_vertical.black": "Rächts swat scheden",
  "block.minecraft.banner.half_vertical.blue": "Rächts blao scheden",
  "block.minecraft.banner.half_vertical.brown": "Rächts bruun scheden",
  "block.minecraft.banner.half_vertical.cyan": "Rächts blaogröön scheden",
  "block.minecraft.banner.half_vertical.gray": "Rächts grao scheden",
  "block.minecraft.banner.half_vertical.green": "Rächts gröön scheden",
  "block.minecraft.banner.half_vertical.light_blue": "Rächts lechtblao scheden",
  "block.minecraft.banner.half_vertical.light_gray": "Rächts gries scheden",
  "block.minecraft.banner.half_vertical.lime": "Rächts lechtgröön scheden",
  "block.minecraft.banner.half_vertical.magenta": "Rächts magenta scheden",
  "block.minecraft.banner.half_vertical.orange": "Rächts geelroot scheden",
  "block.minecraft.banner.half_vertical.pink": "Rächts fienroot scheden",
  "block.minecraft.banner.half_vertical.purple": "Rächts vigelett scheden",
  "block.minecraft.banner.half_vertical.red": "Rächts root scheden",
  "block.minecraft.banner.half_vertical.white": "Rächts witt scheden",
  "block.minecraft.banner.half_vertical.yellow": "Rächts geel scheden",
  "block.minecraft.banner.half_vertical_right.black": "Links swat scheden",
  "block.minecraft.banner.half_vertical_right.blue": "Links blao scheden",
  "block.minecraft.banner.half_vertical_right.brown": "Links bruun scheden",
  "block.minecraft.banner.half_vertical_right.cyan": "Links blaogröön scheden",
  "block.minecraft.banner.half_vertical_right.gray": "Links grao scheden",
  "block.minecraft.banner.half_vertical_right.green": "Links gröön scheden",
  "block.minecraft.banner.half_vertical_right.light_blue": "Links lechtblao scheden",
  "block.minecraft.banner.half_vertical_right.light_gray": "Links gries scheden",
  "block.minecraft.banner.half_vertical_right.lime": "Links lechtgröön scheden",
  "block.minecraft.banner.half_vertical_right.magenta": "Links magenta scheden",
  "block.minecraft.banner.half_vertical_right.orange": "Links geelroot scheden",
  "block.minecraft.banner.half_vertical_right.pink": "Links fienroot scheden",
  "block.minecraft.banner.half_vertical_right.purple": "Links vigelett scheden",
  "block.minecraft.banner.half_vertical_right.red": "Links root scheden",
  "block.minecraft.banner.half_vertical_right.white": "Links witt scheden",
  "block.minecraft.banner.half_vertical_right.yellow": "Links geel scheden",
  "block.minecraft.banner.mojang.black": "Swattes Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaoes Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Bruunes Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Blaogröönes Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graoes Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Gröönes Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Lechtblaoes Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Grieses Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Lechtgröönes Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Geelrootes Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Fienrootes Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Vigelettes Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rootes Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Wittes Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Geeles Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Swatte Schnut",
  "block.minecraft.banner.piglin.blue": "Blaoe Schnut",
  "block.minecraft.banner.piglin.brown": "Bruune Schnut",
  "block.minecraft.banner.piglin.cyan": "Blaogrööne Schnut",
  "block.minecraft.banner.piglin.gray": "Graoe Schnut",
  "block.minecraft.banner.piglin.green": "Grööne Schnut",
  "block.minecraft.banner.piglin.light_blue": "Lechtblaoe Schnut",
  "block.minecraft.banner.piglin.light_gray": "Griese Schnut",
  "block.minecraft.banner.piglin.lime": "Lechtgrööne Schnut",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnut",
  "block.minecraft.banner.piglin.orange": "Geelroote Schnut",
  "block.minecraft.banner.piglin.pink": "Fienroote Schnut",
  "block.minecraft.banner.piglin.purple": "Vigelette Schnut",
  "block.minecraft.banner.piglin.red": "Roote Schnut",
  "block.minecraft.banner.piglin.white": "Witte Schnut",
  "block.minecraft.banner.piglin.yellow": "Geele Schnut",
  "block.minecraft.banner.rhombus.black": "Swatte Ruut",
  "block.minecraft.banner.rhombus.blue": "Blaoe Ruut",
  "block.minecraft.banner.rhombus.brown": "Bruune Ruut",
  "block.minecraft.banner.rhombus.cyan": "Blaogrööne Ruut",
  "block.minecraft.banner.rhombus.gray": "Graoe Ruut",
  "block.minecraft.banner.rhombus.green": "Grööne Ruut",
  "block.minecraft.banner.rhombus.light_blue": "Lechtblaoe Ruut",
  "block.minecraft.banner.rhombus.light_gray": "Griese Ruut",
  "block.minecraft.banner.rhombus.lime": "Lechtgrööne Ruut",
  "block.minecraft.banner.rhombus.magenta": "Magenta Ruut",
  "block.minecraft.banner.rhombus.orange": "Geelroote Ruut",
  "block.minecraft.banner.rhombus.pink": "Fienroote Ruut",
  "block.minecraft.banner.rhombus.purple": "Vigelette Ruut",
  "block.minecraft.banner.rhombus.red": "Roote Ruut",
  "block.minecraft.banner.rhombus.white": "Witte Ruut",
  "block.minecraft.banner.rhombus.yellow": "Geele Ruut",
  "block.minecraft.banner.skull.black": "Swatter Kopp",
  "block.minecraft.banner.skull.blue": "Blaoer Kopp",
  "block.minecraft.banner.skull.brown": "Bruuner Kopp",
  "block.minecraft.banner.skull.cyan": "Blaogrööner Kopp",
  "block.minecraft.banner.skull.gray": "Graoer Kopp",
  "block.minecraft.banner.skull.green": "Grööner Kopp",
  "block.minecraft.banner.skull.light_blue": "Lechtblaoer Kopp",
  "block.minecraft.banner.skull.light_gray": "Grieser Kopp",
  "block.minecraft.banner.skull.lime": "Lechtgrööner Kopp",
  "block.minecraft.banner.skull.magenta": "Magenta Kopp",
  "block.minecraft.banner.skull.orange": "Geelrooter Kopp",
  "block.minecraft.banner.skull.pink": "Fienrooter Kopp",
  "block.minecraft.banner.skull.purple": "Vigeletter Kopp",
  "block.minecraft.banner.skull.red": "Rooter Kopp",
  "block.minecraft.banner.skull.white": "Witter Kopp",
  "block.minecraft.banner.skull.yellow": "Geeler Kopp",
  "block.minecraft.banner.small_stripes.black": "Veer swatte Pahle",
  "block.minecraft.banner.small_stripes.blue": "Veer blaoe Pahle",
  "block.minecraft.banner.small_stripes.brown": "Veer bruune Pahle",
  "block.minecraft.banner.small_stripes.cyan": "Veer blaogrööne Pahle",
  "block.minecraft.banner.small_stripes.gray": "Veer graoe Pahle",
  "block.minecraft.banner.small_stripes.green": "Veer grööne Pahle",
  "block.minecraft.banner.small_stripes.light_blue": "Veer lechtblaoe Pahle",
  "block.minecraft.banner.small_stripes.light_gray": "Veer griese Pahle",
  "block.minecraft.banner.small_stripes.lime": "Veer lechtgrööne Pahle",
  "block.minecraft.banner.small_stripes.magenta": "Veer magenta Pahle",
  "block.minecraft.banner.small_stripes.orange": "Veer geelroote Pahle",
  "block.minecraft.banner.small_stripes.pink": "Veer fienroote Pahle",
  "block.minecraft.banner.small_stripes.purple": "Veer vigelette Pahle",
  "block.minecraft.banner.small_stripes.red": "Veer roote Pahle",
  "block.minecraft.banner.small_stripes.white": "Veer witte Pahle",
  "block.minecraft.banner.small_stripes.yellow": "Veer geele Pahle",
  "block.minecraft.banner.square_bottom_left.black": "Swattes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.blue": "Blaoes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.brown": "Bruunes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.cyan": "Blaogröönes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.gray": "Graoes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.green": "Gröönes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lechtblaoes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Grieses rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.lime": "Lechtgröönes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.orange": "Geelrootes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.pink": "Fienrootes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.purple": "Vigelettes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.red": "Rootes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.white": "Wittes rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_left.yellow": "Geeles rächtes Ünnereck",
  "block.minecraft.banner.square_bottom_right.black": "Swattes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.blue": "Blaoes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.brown": "Bruunes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.cyan": "Blaogröönes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.gray": "Graoes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.green": "Gröönes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lechtblaoes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Grieses lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.lime": "Lechtgröönes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.orange": "Geelrootes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.pink": "Fienrootes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.purple": "Vigelettes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.red": "Rootes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.white": "Wittes lenkes Ünnereck",
  "block.minecraft.banner.square_bottom_right.yellow": "Geeles lenkes Ünnereck",
  "block.minecraft.banner.square_top_left.black": "Swattes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.blue": "Blaoes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.brown": "Bruunes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.cyan": "Blaogröönes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.gray": "Graoes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.green": "Gröönes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.light_blue": "Lechtblaoes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.light_gray": "Grieses rächtes Bövereck",
  "block.minecraft.banner.square_top_left.lime": "Lechtgröönes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.magenta": "Magenta rächtes Bövereck",
  "block.minecraft.banner.square_top_left.orange": "Geelrootes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.pink": "Fienrootes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.purple": "Vigelettes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.red": "Rootes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.white": "Wittes rächtes Bövereck",
  "block.minecraft.banner.square_top_left.yellow": "Geeles rächtes Bövereck",
  "block.minecraft.banner.square_top_right.black": "Swattes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.blue": "Blaoes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.brown": "Bruunes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.cyan": "Blaogröönes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.gray": "Graoes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.green": "Gröönes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.light_blue": "Lechtblaoes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.light_gray": "Grieses lenkes Bövereck",
  "block.minecraft.banner.square_top_right.lime": "Lechtgröönes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.magenta": "Magenta lenkes Bövereck",
  "block.minecraft.banner.square_top_right.orange": "Geelrootes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.pink": "Fienrootes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.purple": "Vigelettes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.red": "Rootes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.white": "Wittes lenkes Bövereck",
  "block.minecraft.banner.square_top_right.yellow": "Geeles lenkes Bövereck",
  "block.minecraft.banner.straight_cross.black": "Swattes Krüüz",
  "block.minecraft.banner.straight_cross.blue": "Blaoes Krüüz",
  "block.minecraft.banner.straight_cross.brown": "Bruunes Krüüz",
  "block.minecraft.banner.straight_cross.cyan": "Blaogröönes Krüüz",
  "block.minecraft.banner.straight_cross.gray": "Graoes Krüüz",
  "block.minecraft.banner.straight_cross.green": "Gröönes Krüüz",
  "block.minecraft.banner.straight_cross.light_blue": "Lechtblaoes Krüüz",
  "block.minecraft.banner.straight_cross.light_gray": "Grieses Krüüz",
  "block.minecraft.banner.straight_cross.lime": "Lechtgröönes Krüüz",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Krüüz",
  "block.minecraft.banner.straight_cross.orange": "Geelrootes Krüüz",
  "block.minecraft.banner.straight_cross.pink": "Fienrootes Krüüz",
  "block.minecraft.banner.straight_cross.purple": "Vigelettes Krüüz",
  "block.minecraft.banner.straight_cross.red": "Rootes Krüüz",
  "block.minecraft.banner.straight_cross.white": "Wittes Krüüz",
  "block.minecraft.banner.straight_cross.yellow": "Geeles Krüüz",
  "block.minecraft.banner.stripe_bottom.black": "Swatter Bannerfot",
  "block.minecraft.banner.stripe_bottom.blue": "Blaoer Bannerfot",
  "block.minecraft.banner.stripe_bottom.brown": "Bruuner Bannerfot",
  "block.minecraft.banner.stripe_bottom.cyan": "Blaogrööner Bannerfot",
  "block.minecraft.banner.stripe_bottom.gray": "Graoer Bannerfot",
  "block.minecraft.banner.stripe_bottom.green": "Grööner Bannerfot",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lechtblaoer Bannerfot",
  "block.minecraft.banner.stripe_bottom.light_gray": "Grieser Bannerfot",
  "block.minecraft.banner.stripe_bottom.lime": "Lechtgrööner Bannerfot",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Bannerfot",
  "block.minecraft.banner.stripe_bottom.orange": "Geelrooter Bannerfot",
  "block.minecraft.banner.stripe_bottom.pink": "Fienrooter Bannerfot",
  "block.minecraft.banner.stripe_bottom.purple": "Vigeletter Bannerfot",
  "block.minecraft.banner.stripe_bottom.red": "Rooter Bannerfot",
  "block.minecraft.banner.stripe_bottom.white": "Witter Bannerfot",
  "block.minecraft.banner.stripe_bottom.yellow": "Geeler Bannerfot",
  "block.minecraft.banner.stripe_center.black": "Swatter Pahl",
  "block.minecraft.banner.stripe_center.blue": "Blaoer Pahl",
  "block.minecraft.banner.stripe_center.brown": "Bruuner Pahl",
  "block.minecraft.banner.stripe_center.cyan": "Blaogrööner Pahl",
  "block.minecraft.banner.stripe_center.gray": "Graoer Pahl",
  "block.minecraft.banner.stripe_center.green": "Grööner Pahl",
  "block.minecraft.banner.stripe_center.light_blue": "Lechtblaoer Pahl",
  "block.minecraft.banner.stripe_center.light_gray": "Grieser Pahl",
  "block.minecraft.banner.stripe_center.lime": "Lechtgrööner Pahl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Pahl",
  "block.minecraft.banner.stripe_center.orange": "Geelrooter Pahl",
  "block.minecraft.banner.stripe_center.pink": "Fienrooter Pahl",
  "block.minecraft.banner.stripe_center.purple": "Vigeletter Pahl",
  "block.minecraft.banner.stripe_center.red": "Rooter Pahl",
  "block.minecraft.banner.stripe_center.white": "Witter Pahl",
  "block.minecraft.banner.stripe_center.yellow": "Geeler Pahl",
  "block.minecraft.banner.stripe_downleft.black": "Swatter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.blue": "Blaoer Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.brown": "Bruuner Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.cyan": "Blaogrööner Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.gray": "Graoer Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.green": "Grööner Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lechtblaoer Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.light_gray": "Grieser Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.lime": "Lechtgrööner Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.orange": "Geelrooter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.pink": "Fienrooter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.purple": "Vigeletter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.red": "Rooter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.white": "Witter Schreeglenksbalk",
  "block.minecraft.banner.stripe_downleft.yellow": "Geeler Schreeglenksbalk",
  "block.minecraft.banner.stripe_downright.black": "Swatter Schreegbalk",
  "block.minecraft.banner.stripe_downright.blue": "Blaoer Schreegbalk",
  "block.minecraft.banner.stripe_downright.brown": "Bruuner Schreegbalk",
  "block.minecraft.banner.stripe_downright.cyan": "Blaogrööner Schreegbalk",
  "block.minecraft.banner.stripe_downright.gray": "Graoer Schreegbalk",
  "block.minecraft.banner.stripe_downright.green": "Grööner Schreegbalk",
  "block.minecraft.banner.stripe_downright.light_blue": "Lechtblaoer Schreegbalk",
  "block.minecraft.banner.stripe_downright.light_gray": "Grieser Schreegbalk",
  "block.minecraft.banner.stripe_downright.lime": "Lechtgrööner Schreegbalk",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Schreegbalk",
  "block.minecraft.banner.stripe_downright.orange": "Geelrooter Schreegbalk",
  "block.minecraft.banner.stripe_downright.pink": "Fienrooter Schreegbalk",
  "block.minecraft.banner.stripe_downright.purple": "Vigeletter Schreegbalk",
  "block.minecraft.banner.stripe_downright.red": "Rooter Schreegbalk",
  "block.minecraft.banner.stripe_downright.white": "Witter Schreegbalk",
  "block.minecraft.banner.stripe_downright.yellow": "Geeler Schreegbalk",
  "block.minecraft.banner.stripe_left.black": "Swatte rächte Flank",
  "block.minecraft.banner.stripe_left.blue": "Blaoe rächte Flank",
  "block.minecraft.banner.stripe_left.brown": "Bruune rächte Flank",
  "block.minecraft.banner.stripe_left.cyan": "Blaogrööne rächte Flank",
  "block.minecraft.banner.stripe_left.gray": "Graoe rächte Flank",
  "block.minecraft.banner.stripe_left.green": "Grööne rächte Flank",
  "block.minecraft.banner.stripe_left.light_blue": "Lechtblaoe rächte Flank",
  "block.minecraft.banner.stripe_left.light_gray": "Griese rächte Flank",
  "block.minecraft.banner.stripe_left.lime": "Lechtgrööne rächte Flank",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rächte Flank",
  "block.minecraft.banner.stripe_left.orange": "Geelroote rächte Flank",
  "block.minecraft.banner.stripe_left.pink": "Fienroote rächte Flank",
  "block.minecraft.banner.stripe_left.purple": "Vigelette rächte Flank",
  "block.minecraft.banner.stripe_left.red": "Roote rächte Flank",
  "block.minecraft.banner.stripe_left.white": "Witte rächte Flank",
  "block.minecraft.banner.stripe_left.yellow": "Geele rächte Flank",
  "block.minecraft.banner.stripe_middle.black": "Swatter Balk",
  "block.minecraft.banner.stripe_middle.blue": "Blaoer Balk",
  "block.minecraft.banner.stripe_middle.brown": "Bruuner Balk",
  "block.minecraft.banner.stripe_middle.cyan": "Blaogrööner Balk",
  "block.minecraft.banner.stripe_middle.gray": "Graoer Balk",
  "block.minecraft.banner.stripe_middle.green": "Grööner Balk",
  "block.minecraft.banner.stripe_middle.light_blue": "Lechtblaoer Balk",
  "block.minecraft.banner.stripe_middle.light_gray": "Grieser Balk",
  "block.minecraft.banner.stripe_middle.lime": "Lechtgrööner Balk",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Balk",
  "block.minecraft.banner.stripe_middle.orange": "Geelrooter Balk",
  "block.minecraft.banner.stripe_middle.pink": "Fienrooter Balk",
  "block.minecraft.banner.stripe_middle.purple": "Vigeletter Balk",
  "block.minecraft.banner.stripe_middle.red": "Rooter Balk",
  "block.minecraft.banner.stripe_middle.white": "Witter Balk",
  "block.minecraft.banner.stripe_middle.yellow": "Geeler Balk",
  "block.minecraft.banner.stripe_right.black": "Swatte lenke Flank",
  "block.minecraft.banner.stripe_right.blue": "Blaoe lenke Flank",
  "block.minecraft.banner.stripe_right.brown": "Bruune lenke Flank",
  "block.minecraft.banner.stripe_right.cyan": "Blaogrööne lenke Flank",
  "block.minecraft.banner.stripe_right.gray": "Graoe lenke Flank",
  "block.minecraft.banner.stripe_right.green": "Grööne lenke Flank",
  "block.minecraft.banner.stripe_right.light_blue": "Lechtblaoe lenke Flank",
  "block.minecraft.banner.stripe_right.light_gray": "Griese lenke Flank",
  "block.minecraft.banner.stripe_right.lime": "Lechtgrööne lenke Flank",
  "block.minecraft.banner.stripe_right.magenta": "Magenta lenke Flank",
  "block.minecraft.banner.stripe_right.orange": "Geelroote lenke Flank",
  "block.minecraft.banner.stripe_right.pink": "Fienroote lenke Flank",
  "block.minecraft.banner.stripe_right.purple": "Vigelette lenke Flank",
  "block.minecraft.banner.stripe_right.red": "Roote lenke Flank",
  "block.minecraft.banner.stripe_right.white": "Witte lenke Flank",
  "block.minecraft.banner.stripe_right.yellow": "Geele lenke Flank",
  "block.minecraft.banner.stripe_top.black": "Swattes Bannerhoupt",
  "block.minecraft.banner.stripe_top.blue": "Blaoes Bannerhoupt",
  "block.minecraft.banner.stripe_top.brown": "Bruunes Bannerhoupt",
  "block.minecraft.banner.stripe_top.cyan": "Blaogröönes Bannerhoupt",
  "block.minecraft.banner.stripe_top.gray": "Graoes Bannerhoupt",
  "block.minecraft.banner.stripe_top.green": "Gröönes Bannerhoupt",
  "block.minecraft.banner.stripe_top.light_blue": "Lechtblaoes Bannerhoupt",
  "block.minecraft.banner.stripe_top.light_gray": "Grieses Bannerhoupt",
  "block.minecraft.banner.stripe_top.lime": "Lechtgröönes Bannerhoupt",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Bannerhoupt",
  "block.minecraft.banner.stripe_top.orange": "Geelrootes Bannerhoupt",
  "block.minecraft.banner.stripe_top.pink": "Fienrootes Bannerhoupt",
  "block.minecraft.banner.stripe_top.purple": "Vigelettes Bannerhoupt",
  "block.minecraft.banner.stripe_top.red": "Rootes Bannerhoupt",
  "block.minecraft.banner.stripe_top.white": "Wittes Bannerhoupt",
  "block.minecraft.banner.stripe_top.yellow": "Geeles Bannerhoupt",
  "block.minecraft.banner.triangle_bottom.black": "Swatte halve Spitz",
  "block.minecraft.banner.triangle_bottom.blue": "Blaoe halve Spitz",
  "block.minecraft.banner.triangle_bottom.brown": "Bruune halve Spitz",
  "block.minecraft.banner.triangle_bottom.cyan": "Blaogrööne halve Spitz",
  "block.minecraft.banner.triangle_bottom.gray": "Graoe halve Spitz",
  "block.minecraft.banner.triangle_bottom.green": "Grööne halve Spitz",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lechtblaoe halve Spitz",
  "block.minecraft.banner.triangle_bottom.light_gray": "Griese halve Spitz",
  "block.minecraft.banner.triangle_bottom.lime": "Lechtgrööne halve Spitz",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta halve Spitz",
  "block.minecraft.banner.triangle_bottom.orange": "Geelroote halve Spitz",
  "block.minecraft.banner.triangle_bottom.pink": "Fienroote halve Spitz",
  "block.minecraft.banner.triangle_bottom.purple": "Vigelette halve Spitz",
  "block.minecraft.banner.triangle_bottom.red": "Roote halve Spitz",
  "block.minecraft.banner.triangle_bottom.white": "Witte halve Spitz",
  "block.minecraft.banner.triangle_bottom.yellow": "Geele halve Spitz",
  "block.minecraft.banner.triangle_top.black": "Swatte gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.blue": "Blaoe gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.brown": "Bruune gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.cyan": "Blaogrööne gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.gray": "Graoe gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.green": "Grööne gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.light_blue": "Lechtblaoe gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.light_gray": "Griese gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.lime": "Lechtgrööne gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.magenta": "Magenta gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.orange": "Geelroote gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.pink": "Fienroote gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.purple": "Vigelette gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.red": "Roote gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.white": "Witte gestürte halve Spitz",
  "block.minecraft.banner.triangle_top.yellow": "Geele gestürte halve Spitz",
  "block.minecraft.banner.triangles_bottom.black": "Swatter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.blue": "Blaoer gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.brown": "Bruuner gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.cyan": "Blaogrööner gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.gray": "Graoer gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.green": "Grööner gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lechtblaoer gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.light_gray": "Grieser gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.lime": "Lechtgrööner gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.orange": "Geelrooter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.pink": "Fienrooter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.purple": "Vigeletter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.red": "Rooter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.white": "Witter gespickelter Bannerfot",
  "block.minecraft.banner.triangles_bottom.yellow": "Geeler gespickelter Bannerfot",
  "block.minecraft.banner.triangles_top.black": "Swattes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.blue": "Blaoes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.brown": "Bruunes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.cyan": "Blaogröönes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.gray": "Graoes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.green": "Gröönes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.light_blue": "Lechtblaoes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.light_gray": "Grieses sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.lime": "Lechtgröönes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.magenta": "Magenta sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.orange": "Geelrootes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.pink": "Fienrootes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.purple": "Vigelettes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.red": "Rootes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.white": "Wittes sprööges Bannerhoupt",
  "block.minecraft.banner.triangles_top.yellow": "Geeles sprööges Bannerhoupt",
  "block.minecraft.barrel": "Fatt",
  "block.minecraft.barrier": "Barreer",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Löchtfüer",
  "block.minecraft.beacon.primary": "Höftkraft",
  "block.minecraft.beacon.secondary": "Tweekraft",
  "block.minecraft.bed.no_sleep": "Du kanst bloot nachtens of wiels en Dunnerwiär slapen",
  "block.minecraft.bed.not_safe": "Du kanst nu nich slapen, dat sünd Beester in de Neeg",
  "block.minecraft.bed.obstructed": "Dat Bedd is verhinnert",
  "block.minecraft.bed.occupied": "Düt Bedde is belägt",
  "block.minecraft.bed.too_far_away": "Du könt nich slapen, dat Bedd is to wied ofgelegen",
  "block.minecraft.bedrock": "Grundsteen",
  "block.minecraft.bee_nest": "Immennest",
  "block.minecraft.beehive": "Immenstock",
  "block.minecraft.beetroots": "Roote Beet",
  "block.minecraft.bell": "Klock",
  "block.minecraft.big_dripleaf": "Groot Treppblatt",
  "block.minecraft.big_dripleaf_stem": "Groot Treppblattsteel",
  "block.minecraft.birch_button": "Biäkenholtknop",
  "block.minecraft.birch_door": "Biäkendüör",
  "block.minecraft.birch_fence": "Biäkentuun",
  "block.minecraft.birch_fence_gate": "Biäkenholttuunpaort",
  "block.minecraft.birch_hanging_sign": "Birch Hanging Sign",
  "block.minecraft.birch_leaves": "Biäkenbliäder",
  "block.minecraft.birch_log": "Biäkenstam",
  "block.minecraft.birch_planks": "Biäkenholtbreden",
  "block.minecraft.birch_pressure_plate": "Biäkenholtdrukplaat",
  "block.minecraft.birch_sapling": "Biäkensetter",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Biäkenholtschild",
  "block.minecraft.birch_slab": "Biäkenholtplaat",
  "block.minecraft.birch_stairs": "Biäkenholttrapp",
  "block.minecraft.birch_trapdoor": "Biäkenholtluuk",
  "block.minecraft.birch_wall_hanging_sign": "Birch Wall Hanging Sign",
  "block.minecraft.birch_wall_sign": "Biäkenholtmüerschild",
  "block.minecraft.birch_wood": "Biäkenholt",
  "block.minecraft.black_banner": "Swattes Banner",
  "block.minecraft.black_bed": "Swattes Bedd",
  "block.minecraft.black_candle": "Swattes Lücht",
  "block.minecraft.black_candle_cake": "Koken met swattem Lücht",
  "block.minecraft.black_carpet": "Swatter Teppich",
  "block.minecraft.black_concrete": "Swatter Beton",
  "block.minecraft.black_concrete_powder": "Swatter Dröögbeton",
  "block.minecraft.black_glazed_terracotta": "Swatte glaseerte Keramik",
  "block.minecraft.black_shulker_box": "Swatte Shulker-Kist",
  "block.minecraft.black_stained_glass": "Swattes Glas",
  "block.minecraft.black_stained_glass_pane": "Swatte Glasschiwe",
  "block.minecraft.black_terracotta": "Swatte Keramik",
  "block.minecraft.black_wool": "Swatte Wulle",
  "block.minecraft.blackstone": "Swatsteen",
  "block.minecraft.blackstone_slab": "Swatsteenplaat",
  "block.minecraft.blackstone_stairs": "Swatsteentrapp",
  "block.minecraft.blackstone_wall": "Swatsteenmüer",
  "block.minecraft.blast_furnace": "Smöltaven",
  "block.minecraft.blue_banner": "Blaoes Banner",
  "block.minecraft.blue_bed": "Blaoes Bedd",
  "block.minecraft.blue_candle": "Blaoes Lücht",
  "block.minecraft.blue_candle_cake": "Koken met blaoem Lücht",
  "block.minecraft.blue_carpet": "Blaoer Teppich",
  "block.minecraft.blue_concrete": "Blaoer Beton",
  "block.minecraft.blue_concrete_powder": "Blaoer Dröögbeton",
  "block.minecraft.blue_glazed_terracotta": "Blaoe glaseerte Keramik",
  "block.minecraft.blue_ice": "Blaoies",
  "block.minecraft.blue_orchid": "Blaoe Orchidee",
  "block.minecraft.blue_shulker_box": "Blaoe Shulker-Kist",
  "block.minecraft.blue_stained_glass": "Blaoes Glas",
  "block.minecraft.blue_stained_glass_pane": "Blaoe Glasschiwe",
  "block.minecraft.blue_terracotta": "Blaoe Keramik",
  "block.minecraft.blue_wool": "Blaoe Wulle",
  "block.minecraft.bone_block": "Beenblok",
  "block.minecraft.bookshelf": "Bökerschap",
  "block.minecraft.brain_coral": "Bregenkorall",
  "block.minecraft.brain_coral_block": "Bregenkorallblok",
  "block.minecraft.brain_coral_fan": "Bregenkorallwaier",
  "block.minecraft.brain_coral_wall_fan": "Bregenkorallmüerwaier",
  "block.minecraft.brewing_stand": "Brustand",
  "block.minecraft.brick_slab": "Tegelplaat",
  "block.minecraft.brick_stairs": "Tegeltrapp",
  "block.minecraft.brick_wall": "Tegelmüer",
  "block.minecraft.bricks": "Tegelsteen",
  "block.minecraft.brown_banner": "Bruunes Banner",
  "block.minecraft.brown_bed": "Bruunes Bedd",
  "block.minecraft.brown_candle": "Bruunes Lücht",
  "block.minecraft.brown_candle_cake": "Koken met bruunem Lücht",
  "block.minecraft.brown_carpet": "Bruner Teppich",
  "block.minecraft.brown_concrete": "Bruuner Beton",
  "block.minecraft.brown_concrete_powder": "Bruuner Dröögbeton",
  "block.minecraft.brown_glazed_terracotta": "Bruune glaseerte Keramik",
  "block.minecraft.brown_mushroom": "Bruune Poggenstool",
  "block.minecraft.brown_mushroom_block": "Bruune Poggenstoolblok",
  "block.minecraft.brown_shulker_box": "Bruune Shulker-Kist",
  "block.minecraft.brown_stained_glass": "Bruunes Glas",
  "block.minecraft.brown_stained_glass_pane": "Brune Glasschiwe",
  "block.minecraft.brown_terracotta": "Bruune Keramik",
  "block.minecraft.brown_wool": "Bruune Wulle",
  "block.minecraft.bubble_column": "Blaasnsüle",
  "block.minecraft.bubble_coral": "Blaasnkorall",
  "block.minecraft.bubble_coral_block": "Blaasnkorallblok",
  "block.minecraft.bubble_coral_fan": "Blaasnkorallwaier",
  "block.minecraft.bubble_coral_wall_fan": "Blaasnkorallmüerwaier",
  "block.minecraft.budding_amethyst": "Amethystknosknuppblok",
  "block.minecraft.bush": "Busk",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Koken",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated Sculk Sensor",
  "block.minecraft.campfire": "Loagafia",
  "block.minecraft.candle": "Lücht",
  "block.minecraft.candle_cake": "Koken met Lücht",
  "block.minecraft.carrots": "Wuddels",
  "block.minecraft.cartography_table": "Kaarttafel",
  "block.minecraft.carved_pumpkin": "Snidden Kävers",
  "block.minecraft.cauldron": "Ketel",
  "block.minecraft.cave_air": "Hüölenluft",
  "block.minecraft.cave_vines": "Hüölenranken",
  "block.minecraft.cave_vines_plant": "Hüölenrankenplant",
  "block.minecraft.chain": "Kädde",
  "block.minecraft.chain_command_block": "Kädden-Befiälsblök",
  "block.minecraft.cherry_button": "Cherry Button",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Cherry Fence",
  "block.minecraft.cherry_fence_gate": "Cherry Fence Gate",
  "block.minecraft.cherry_hanging_sign": "Cherry Hanging Sign",
  "block.minecraft.cherry_leaves": "Cherry Leaves",
  "block.minecraft.cherry_log": "Cherry Log",
  "block.minecraft.cherry_planks": "Cherry Planks",
  "block.minecraft.cherry_pressure_plate": "Cherry Pressure Plate",
  "block.minecraft.cherry_sapling": "Cherry Sapling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Cherry Sign",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Kassenbloomholttrapp",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Cherry Wall Hanging Sign",
  "block.minecraft.cherry_wall_sign": "Cherry Wall Sign",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Truh",
  "block.minecraft.chipped_anvil": "Afbrakt Ambold",
  "block.minecraft.chiseled_bookshelf": "Chiseled Bookshelf",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Baitelte Deefschiever",
  "block.minecraft.chiseled_nether_bricks": "Baitelte Nethertegel",
  "block.minecraft.chiseled_polished_blackstone": "Baitelt poleerter Swatsteen",
  "block.minecraft.chiseled_quartz_block": "Baitelter Kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Baitelte roote Sandsteen",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Baitelt Sandsteen",
  "block.minecraft.chiseled_stone_bricks": "Baitelte Steentegel",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Chorusblööt",
  "block.minecraft.chorus_plant": "Chorusplant",
  "block.minecraft.clay": "Klai",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Kuoleblok",
  "block.minecraft.coal_ore": "Steenkuole",
  "block.minecraft.coarse_dirt": "Gruowe Äer",
  "block.minecraft.cobbled_deepslate": "Bröökdeefschiever",
  "block.minecraft.cobbled_deepslate_slab": "Bröökdeefschieverplaat",
  "block.minecraft.cobbled_deepslate_stairs": "Bröökdeefschievertrapp",
  "block.minecraft.cobbled_deepslate_wall": "Bröökdeefschievermüer",
  "block.minecraft.cobblestone": "Brööksteen",
  "block.minecraft.cobblestone_slab": "Brööksteenplaat",
  "block.minecraft.cobblestone_stairs": "Brööksteentrapp",
  "block.minecraft.cobblestone_wall": "Brööksteenmüer",
  "block.minecraft.cobweb": "Spinkopnöst",
  "block.minecraft.cocoa": "Kakau",
  "block.minecraft.command_block": "Befiälsblok",
  "block.minecraft.comparator": "Redstone-Komparator",
  "block.minecraft.composter": "Kumposter",
  "block.minecraft.conduit": "Akwisator",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Kopperblok",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Kopperärts",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Koornblööm",
  "block.minecraft.cracked_deepslate_bricks": "Bürstige Deefschievertegel",
  "block.minecraft.cracked_deepslate_tiles": "Bürstige Deefschieverfliesen",
  "block.minecraft.cracked_nether_bricks": "Bürstige Nethertegel",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bürstige poleerte Swatsteentegel",
  "block.minecraft.cracked_stone_bricks": "Bürstige Steentegel",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Wiärkbank",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeperkopp",
  "block.minecraft.creeper_wall_head": "Creeper-Müerkopp",
  "block.minecraft.crimson_button": "Purpurootknop",
  "block.minecraft.crimson_door": "Purpurootdüör",
  "block.minecraft.crimson_fence": "Purpuroottuun",
  "block.minecraft.crimson_fence_gate": "Purpuroottuunpaort",
  "block.minecraft.crimson_fungus": "Purpurootpilz",
  "block.minecraft.crimson_hanging_sign": "Crimson Hanging Sign",
  "block.minecraft.crimson_hyphae": "Purpuroothyphen",
  "block.minecraft.crimson_nylium": "Purpuroot-Nezel",
  "block.minecraft.crimson_planks": "Purpurrootbreden",
  "block.minecraft.crimson_pressure_plate": "Purpurootdrukplaat",
  "block.minecraft.crimson_roots": "Purpurootwörteln",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Purpurootschild",
  "block.minecraft.crimson_slab": "Purpurootplaat",
  "block.minecraft.crimson_stairs": "Purpuroottrapp",
  "block.minecraft.crimson_stem": "Purpurootplant",
  "block.minecraft.crimson_trapdoor": "Purpurootluuk",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall Hanging Sign",
  "block.minecraft.crimson_wall_sign": "Purpurootmüerschild",
  "block.minecraft.crying_obsidian": "Wienner Gnetersteen",
  "block.minecraft.cut_copper": "Snieden Kopperblok",
  "block.minecraft.cut_copper_slab": "Snieden Kopperplaat",
  "block.minecraft.cut_copper_stairs": "Snieden Koppertrapp",
  "block.minecraft.cut_red_sandstone": "Snieden roote Sandsteen",
  "block.minecraft.cut_red_sandstone_slab": "Snieden roote Sandsteenplaat",
  "block.minecraft.cut_sandstone": "Snieden Sandsteen",
  "block.minecraft.cut_sandstone_slab": "Snieden Sandsteenplaat",
  "block.minecraft.cyan_banner": "Blaogröönes Banner",
  "block.minecraft.cyan_bed": "Blaogröönes Bedd",
  "block.minecraft.cyan_candle": "Blaogröönes Lücht",
  "block.minecraft.cyan_candle_cake": "Koken met blaogröönem Lücht",
  "block.minecraft.cyan_carpet": "Blaogrööner Teppich",
  "block.minecraft.cyan_concrete": "Blaogrööner Beton",
  "block.minecraft.cyan_concrete_powder": "Blaogrööner Dröögbeton",
  "block.minecraft.cyan_glazed_terracotta": "Blaogrööne glaseerte Keramik",
  "block.minecraft.cyan_shulker_box": "Blaogrööne Shulker-Kist",
  "block.minecraft.cyan_stained_glass": "Blaogröönes Glas",
  "block.minecraft.cyan_stained_glass_pane": "Blaogrööne Glasschiwe",
  "block.minecraft.cyan_terracotta": "Blaogrööne Keramik",
  "block.minecraft.cyan_wool": "Blaogrööne Wulle",
  "block.minecraft.damaged_anvil": "Vönailter Ambold",
  "block.minecraft.dandelion": "Kiëdenblome",
  "block.minecraft.dark_oak_button": "Swatekenholtknop",
  "block.minecraft.dark_oak_door": "Swatekendüör",
  "block.minecraft.dark_oak_fence": "Swatekenholttuun",
  "block.minecraft.dark_oak_fence_gate": "Swatekenholttuunpaort",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Sign",
  "block.minecraft.dark_oak_leaves": "Swatekenbliäder",
  "block.minecraft.dark_oak_log": "Swatekenstam",
  "block.minecraft.dark_oak_planks": "Swatekenholtbreden",
  "block.minecraft.dark_oak_pressure_plate": "Swatekenholtdrukplaat",
  "block.minecraft.dark_oak_sapling": "Swatekensetter",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Swatekenholtschild",
  "block.minecraft.dark_oak_slab": "Swatekenholtplaat",
  "block.minecraft.dark_oak_stairs": "Swatekenholttrapp",
  "block.minecraft.dark_oak_trapdoor": "Swatekenholtluuk",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Sign",
  "block.minecraft.dark_oak_wall_sign": "Swatekenholtmüerschild",
  "block.minecraft.dark_oak_wood": "Swatekenholt",
  "block.minecraft.dark_prismarine": "Düüster Prismarien",
  "block.minecraft.dark_prismarine_slab": "Düüster Prismarienplaat",
  "block.minecraft.dark_prismarine_stairs": "Düüster Prismarientrapp",
  "block.minecraft.daylight_detector": "Dageslechtföler",
  "block.minecraft.dead_brain_coral": "Doote Bregenkorall",
  "block.minecraft.dead_brain_coral_block": "Dooter Bregenkorallblok",
  "block.minecraft.dead_brain_coral_fan": "Dooter Bregenkorallwaier",
  "block.minecraft.dead_brain_coral_wall_fan": "Dooter Bregenkorallmüerwaier",
  "block.minecraft.dead_bubble_coral": "Doote Blaasnkorall",
  "block.minecraft.dead_bubble_coral_block": "Doote Blaasnkorallblok",
  "block.minecraft.dead_bubble_coral_fan": "Doote Blaasnkorallwaier",
  "block.minecraft.dead_bubble_coral_wall_fan": "Doote Blaasnkorallmüerwaier",
  "block.minecraft.dead_bush": "Dooter Busk",
  "block.minecraft.dead_fire_coral": "Doote Füerkorall",
  "block.minecraft.dead_fire_coral_block": "Dooter Füerkorallblok",
  "block.minecraft.dead_fire_coral_fan": "Dooter Füerkorallwaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Dooter Füerkorallmüerblok",
  "block.minecraft.dead_horn_coral": "Doote Hoornkorall",
  "block.minecraft.dead_horn_coral_block": "Doote Hoornkorallblok",
  "block.minecraft.dead_horn_coral_fan": "Doote Hoornkorallwaier",
  "block.minecraft.dead_horn_coral_wall_fan": "Doote Hoornkorallmüerwaier",
  "block.minecraft.dead_tube_coral": "Doote Röhrkorall",
  "block.minecraft.dead_tube_coral_block": "Dooter Röhrkorallblok",
  "block.minecraft.dead_tube_coral_fan": "Dooter Röhrkorallwaier",
  "block.minecraft.dead_tube_coral_wall_fan": "Dooter Röhrkorallmüerwaier",
  "block.minecraft.decorated_pot": "Decorated Pot",
  "block.minecraft.deepslate": "Deefschiever",
  "block.minecraft.deepslate_brick_slab": "Deefschievertegeltrapp",
  "block.minecraft.deepslate_brick_stairs": "Deefschievertegelplaat",
  "block.minecraft.deepslate_brick_wall": "Deefschievertegelmüer",
  "block.minecraft.deepslate_bricks": "Deefschievertegel",
  "block.minecraft.deepslate_coal_ore": "Deefschiever-Steenkuole",
  "block.minecraft.deepslate_copper_ore": "Deefschiever-Kopperärts",
  "block.minecraft.deepslate_diamond_ore": "Deefschiever-Demantärts",
  "block.minecraft.deepslate_emerald_ore": "Deefschiever-Smaragdärts",
  "block.minecraft.deepslate_gold_ore": "Deefschiever-Güldärts",
  "block.minecraft.deepslate_iron_ore": "Deefschiever-Isenärts",
  "block.minecraft.deepslate_lapis_ore": "Deefschiever-Lapislatsuliärts",
  "block.minecraft.deepslate_redstone_ore": "Deefschiever-Redstone-Ärts",
  "block.minecraft.deepslate_tile_slab": "Deefschieverfliesenplaat",
  "block.minecraft.deepslate_tile_stairs": "Deefschieverfliesentrapp",
  "block.minecraft.deepslate_tile_wall": "Deefschieverfliesenmüer",
  "block.minecraft.deepslate_tiles": "Deefschieverfliesen",
  "block.minecraft.detector_rail": "Fölerschine",
  "block.minecraft.diamond_block": "Demantblok",
  "block.minecraft.diamond_ore": "Demantärts",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Diorittrapp",
  "block.minecraft.diorite_stairs": "Diorittrapp",
  "block.minecraft.diorite_wall": "Dioritmüer",
  "block.minecraft.dirt": "Äer",
  "block.minecraft.dirt_path": "Tramppadd",
  "block.minecraft.dispenser": "Audomaat",
  "block.minecraft.dragon_egg": "Draakei",
  "block.minecraft.dragon_head": "Draakkopp",
  "block.minecraft.dragon_wall_head": "Draaken-Müerkopp",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Dröger Tangblok",
  "block.minecraft.dripstone_block": "Treppsteenblok",
  "block.minecraft.dropper": "Giëwer",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragdärts",
  "block.minecraft.enchanting_table": "Betöverungstafel",
  "block.minecraft.end_gateway": "Endtranitalpaortaal",
  "block.minecraft.end_portal": "Endpaortaal",
  "block.minecraft.end_portal_frame": "Endpaortaalraam",
  "block.minecraft.end_rod": "Endstaav",
  "block.minecraft.end_stone": "Endsteen",
  "block.minecraft.end_stone_brick_slab": "Endsteentegelplaat",
  "block.minecraft.end_stone_brick_stairs": "Endsteentegeltrapp",
  "block.minecraft.end_stone_brick_wall": "Endsteentegelmüer",
  "block.minecraft.end_stone_bricks": "Endsteentegel",
  "block.minecraft.ender_chest": "Endertruh",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Anlopt Kopperblok",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Anlopt snieden Kopperblok",
  "block.minecraft.exposed_cut_copper_slab": "Anlopt snieden Kopperplaat",
  "block.minecraft.exposed_cut_copper_stairs": "Anlopt snieden Koppertrapp",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Plügland",
  "block.minecraft.fern": "Faon",
  "block.minecraft.fire": "Füer",
  "block.minecraft.fire_coral": "Füerkorall",
  "block.minecraft.fire_coral_block": "Füerkorallblok",
  "block.minecraft.fire_coral_fan": "Füerkorallwaier",
  "block.minecraft.fire_coral_wall_fan": "Füerkorallmüerwaier",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Buogtafel",
  "block.minecraft.flower_pot": "Blöömpott",
  "block.minecraft.flowering_azalea": "Blöhende Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blöhendes Azaleenlauv",
  "block.minecraft.frogspawn": "Froschbrut",
  "block.minecraft.frosted_ice": "Brökeirg Ies",
  "block.minecraft.furnace": "Aven",
  "block.minecraft.gilded_blackstone": "Gülddörsnitt Swatsteen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasschiwe",
  "block.minecraft.glow_lichen": "Lüchtflecht",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Güldblok",
  "block.minecraft.gold_ore": "Güldärts",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitplaat",
  "block.minecraft.granite_stairs": "Granittrapp",
  "block.minecraft.granite_wall": "Granitmüer",
  "block.minecraft.grass": "Gräs",
  "block.minecraft.grass_block": "Gräsblok",
  "block.minecraft.gravel": "Grand",
  "block.minecraft.gray_banner": "Graoes Banner",
  "block.minecraft.gray_bed": "Graoes Bedd",
  "block.minecraft.gray_candle": "Graoes Lücht",
  "block.minecraft.gray_candle_cake": "Koken met graoem Lücht",
  "block.minecraft.gray_carpet": "Graoer Teppich",
  "block.minecraft.gray_concrete": "Graoer Beton",
  "block.minecraft.gray_concrete_powder": "Graoer Dröögbeton",
  "block.minecraft.gray_glazed_terracotta": "Graoe glaseerte Keramik",
  "block.minecraft.gray_shulker_box": "Graoe Shulker-Kist",
  "block.minecraft.gray_stained_glass": "Graoes Glas",
  "block.minecraft.gray_stained_glass_pane": "Graoe Glasschiwe",
  "block.minecraft.gray_terracotta": "Graoe Keramik",
  "block.minecraft.gray_wool": "Graoe Wulle",
  "block.minecraft.green_banner": "Gröönes Banner",
  "block.minecraft.green_bed": "Gröönes Bedd",
  "block.minecraft.green_candle": "Gröönes Lücht",
  "block.minecraft.green_candle_cake": "Koken met gröönem Lücht",
  "block.minecraft.green_carpet": "Grööner Teppich",
  "block.minecraft.green_concrete": "Grööner Beton",
  "block.minecraft.green_concrete_powder": "Grööner Dröögbeton",
  "block.minecraft.green_glazed_terracotta": "Grööne glaseerte Keramik",
  "block.minecraft.green_shulker_box": "Grööne Shulker-Kist",
  "block.minecraft.green_stained_glass": "Gröönes Glas",
  "block.minecraft.green_stained_glass_pane": "Grööne Glasschiwe",
  "block.minecraft.green_terracotta": "Grööne Keramik",
  "block.minecraft.green_wool": "Grööne Wulle",
  "block.minecraft.grindstone": "Sliepsteen",
  "block.minecraft.hanging_roots": "Hangwuddeln",
  "block.minecraft.hay_block": "Haidut",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Swaarwichtigdrukplaat",
  "block.minecraft.honey_block": "Hönnigblok",
  "block.minecraft.honeycomb_block": "Hönnigwaarblok",
  "block.minecraft.hopper": "Trächter",
  "block.minecraft.horn_coral": "Hoornkorall",
  "block.minecraft.horn_coral_block": "Hoornkorallblok",
  "block.minecraft.horn_coral_fan": "Doote Hoornkorallwaier",
  "block.minecraft.horn_coral_wall_fan": "Hoornkorallmüerwaier",
  "block.minecraft.ice": "Ies",
  "block.minecraft.infested_chiseled_stone_bricks": "Befallene baitelte Steentegel",
  "block.minecraft.infested_cobblestone": "Befallener Brööksteen",
  "block.minecraft.infested_cracked_stone_bricks": "Befallene bürstige Steentegel",
  "block.minecraft.infested_deepslate": "Befallener Deefschiever",
  "block.minecraft.infested_mossy_stone_bricks": "Befallene mussige Steentegel",
  "block.minecraft.infested_stone": "Befallener Steen",
  "block.minecraft.infested_stone_bricks": "Befallene Steentegel",
  "block.minecraft.iron_bars": "Isentralg",
  "block.minecraft.iron_block": "Isenblok",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Isendüör",
  "block.minecraft.iron_ore": "Isenärts",
  "block.minecraft.iron_trapdoor": "Isenluuk",
  "block.minecraft.jack_o_lantern": "Käverslücht",
  "block.minecraft.jigsaw": "Verbünnelblok",
  "block.minecraft.jukebox": "Grammofoon",
  "block.minecraft.jungle_button": "Oorwooldholtknop",
  "block.minecraft.jungle_door": "Oorwoolddüör",
  "block.minecraft.jungle_fence": "Oorwooldtuun",
  "block.minecraft.jungle_fence_gate": "Oorwooldtuunpaort",
  "block.minecraft.jungle_hanging_sign": "Jungle Hanging Sign",
  "block.minecraft.jungle_leaves": "Oorwooldbliäder",
  "block.minecraft.jungle_log": "Oorwooldstam",
  "block.minecraft.jungle_planks": "Oorwooldholtbreden",
  "block.minecraft.jungle_pressure_plate": "Oorwooldholtdrukplaat",
  "block.minecraft.jungle_sapling": "Oorwooldsetter",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Oorwooldholtschild",
  "block.minecraft.jungle_slab": "Oorwooldholtplaat",
  "block.minecraft.jungle_stairs": "Oorwooldholttrapp",
  "block.minecraft.jungle_trapdoor": "Oorwooldholtluuk",
  "block.minecraft.jungle_wall_hanging_sign": "Jungle Wall Hanging Sign",
  "block.minecraft.jungle_wall_sign": "Oorwooldholtmüerschild",
  "block.minecraft.jungle_wood": "Oorwooldholt",
  "block.minecraft.kelp": "Tang",
  "block.minecraft.kelp_plant": "Tangstrunk",
  "block.minecraft.ladder": "Ledder",
  "block.minecraft.lantern": "Lateern",
  "block.minecraft.lapis_block": "Lapislatsuliblok",
  "block.minecraft.lapis_ore": "Lapislatsuliärts",
  "block.minecraft.large_amethyst_bud": "Graute Amethystknosknupp",
  "block.minecraft.large_fern": "Graut Faon",
  "block.minecraft.lava": "Lawa",
  "block.minecraft.lava_cauldron": "Lawaketel",
  "block.minecraft.leaf_litter": "Loov",
  "block.minecraft.lectern": "Leespult",
  "block.minecraft.lever": "Hiäwel",
  "block.minecraft.light": "Lüchtblok",
  "block.minecraft.light_blue_banner": "Lechtblaoes Banner",
  "block.minecraft.light_blue_bed": "Lechtblaoes Bedd",
  "block.minecraft.light_blue_candle": "Lechtblaoes Lücht",
  "block.minecraft.light_blue_candle_cake": "Koken met lechtblaoem Lücht",
  "block.minecraft.light_blue_carpet": "Lechtblaoer Teppich",
  "block.minecraft.light_blue_concrete": "Lechtblaoer Beton",
  "block.minecraft.light_blue_concrete_powder": "Lechtblaoer Dröögbeton",
  "block.minecraft.light_blue_glazed_terracotta": "Lechtblaoe glaseerte Keramik",
  "block.minecraft.light_blue_shulker_box": "Lechtblaoe Shulker-Kist",
  "block.minecraft.light_blue_stained_glass": "Lechtblaoes Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Lechtblaoe Glasschiwe",
  "block.minecraft.light_blue_terracotta": "Lechtblaoe Keramik",
  "block.minecraft.light_blue_wool": "Lechtblaoe Wulle",
  "block.minecraft.light_gray_banner": "Grieses Banner",
  "block.minecraft.light_gray_bed": "Grieses Bedd",
  "block.minecraft.light_gray_candle": "Grieses Lücht",
  "block.minecraft.light_gray_candle_cake": "Koken met griesem Lücht",
  "block.minecraft.light_gray_carpet": "Grieser Teppich",
  "block.minecraft.light_gray_concrete": "Grieser Beton",
  "block.minecraft.light_gray_concrete_powder": "Grieser Dröögbeton",
  "block.minecraft.light_gray_glazed_terracotta": "Griese glaseerte Keramik",
  "block.minecraft.light_gray_shulker_box": "Griese Shulker-Kist",
  "block.minecraft.light_gray_stained_glass": "Grieses Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Griese Glasschiwe",
  "block.minecraft.light_gray_terracotta": "Griese Keramik",
  "block.minecraft.light_gray_wool": "Griese Wulle",
  "block.minecraft.light_weighted_pressure_plate": "Lichtwichtigdrukplaat",
  "block.minecraft.lightning_rod": "Blitzafleider",
  "block.minecraft.lilac": "Nagelblome",
  "block.minecraft.lily_of_the_valley": "Maiklockje",
  "block.minecraft.lily_pad": "Waterrausenblad",
  "block.minecraft.lime_banner": "Lechtgröönes Banner",
  "block.minecraft.lime_bed": "Lechtgröönes Bedd",
  "block.minecraft.lime_candle": "Lechtgröönes Lücht",
  "block.minecraft.lime_candle_cake": "Koken met lechtgröönem Lücht",
  "block.minecraft.lime_carpet": "Lechtgrööner Teppich",
  "block.minecraft.lime_concrete": "Lechtgrööner Beton",
  "block.minecraft.lime_concrete_powder": "Lechtgrööner Dröögbeton",
  "block.minecraft.lime_glazed_terracotta": "Lechtgrööne glaseerte Keramik",
  "block.minecraft.lime_shulker_box": "Lechtgrööne Shulker-Kist",
  "block.minecraft.lime_stained_glass": "Lechtgröönes Glas",
  "block.minecraft.lime_stained_glass_pane": "Lechtgrööne Glasschiwe",
  "block.minecraft.lime_terracotta": "Lechtgrööne Keramik",
  "block.minecraft.lime_wool": "Lechtgrööne Wulle",
  "block.minecraft.lodestone": "Leitsteen",
  "block.minecraft.loom": "Weevstohl",
  "block.minecraft.magenta_banner": "Magenta Banner",
  "block.minecraft.magenta_bed": "Magenta Bedd",
  "block.minecraft.magenta_candle": "Magenta Lücht",
  "block.minecraft.magenta_candle_cake": "Koken met magenta Lücht",
  "block.minecraft.magenta_carpet": "Magenta Teppich",
  "block.minecraft.magenta_concrete": "Magenta Beton",
  "block.minecraft.magenta_concrete_powder": "Magenta Dröögbeton",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glaseerte Keramik",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker-Kist",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glasschiwe",
  "block.minecraft.magenta_terracotta": "Magenta Keramik",
  "block.minecraft.magenta_wool": "Magenta Wulle",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovenknopf",
  "block.minecraft.mangrove_door": "Mangroventür",
  "block.minecraft.mangrove_fence": "Mangrovenzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovenzaun-Tor",
  "block.minecraft.mangrove_hanging_sign": "Mangrove Hanging Sign",
  "block.minecraft.mangrove_leaves": "Mangrovenblätter",
  "block.minecraft.mangrove_log": "Mangrovenstamm",
  "block.minecraft.mangrove_planks": "Mangrovenpflanzen",
  "block.minecraft.mangrove_pressure_plate": "Mangroven-Druckplatte",
  "block.minecraft.mangrove_propagule": "Mangroven-Vermehrung",
  "block.minecraft.mangrove_roots": "Mangrovenwurzeln",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangroven-Zeichen",
  "block.minecraft.mangrove_slab": "Mangrovenplatte",
  "block.minecraft.mangrove_stairs": "Mangrovenholttrapp",
  "block.minecraft.mangrove_trapdoor": "Mangroven-Falltür",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall Hanging Sign",
  "block.minecraft.mangrove_wall_sign": "Mangroven-Wandschild",
  "block.minecraft.mangrove_wood": "Mangrovenholz",
  "block.minecraft.medium_amethyst_bud": "Middel Amethystknosknupp",
  "block.minecraft.melon": "Meloon",
  "block.minecraft.melon_stem": "Meloonplant",
  "block.minecraft.moss_block": "Moosblok",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Mussige Plaostersteen",
  "block.minecraft.mossy_cobblestone_slab": "Mussige Brööksteenplaat",
  "block.minecraft.mossy_cobblestone_stairs": "Mussige Brööksteentrapp",
  "block.minecraft.mossy_cobblestone_wall": "Mussige Brööksteenmüer",
  "block.minecraft.mossy_stone_brick_slab": "Mussige Steentegelplaat",
  "block.minecraft.mossy_stone_brick_stairs": "Mussige Steentegeltrapp",
  "block.minecraft.mossy_stone_brick_wall": "Mussige Steentegelmüer",
  "block.minecraft.mossy_stone_bricks": "Mussige Steentegel",
  "block.minecraft.moving_piston": "Bewegter Blok",
  "block.minecraft.mud": "Mööt",
  "block.minecraft.mud_brick_slab": "Mööttegelplaat",
  "block.minecraft.mud_brick_stairs": "Mööttegeltrapp",
  "block.minecraft.mud_brick_wall": "Mööttegelmüer",
  "block.minecraft.mud_bricks": "Mööttegels",
  "block.minecraft.muddy_mangrove_roots": "Schlammige Mangrovenwurzeln",
  "block.minecraft.mushroom_stem": "Poggenstoolsteel",
  "block.minecraft.mycelium": "Mütseel",
  "block.minecraft.nether_brick_fence": "Nethertegeltuun",
  "block.minecraft.nether_brick_slab": "Nethertegelplaat",
  "block.minecraft.nether_brick_stairs": "Nethertegeltrapp",
  "block.minecraft.nether_brick_wall": "Nethertegelmüer",
  "block.minecraft.nether_bricks": "Nethertegel",
  "block.minecraft.nether_gold_ore": "Nethergüldärts",
  "block.minecraft.nether_portal": "Netherpaortaal",
  "block.minecraft.nether_quartz_ore": "Netherquartzärts",
  "block.minecraft.nether_sprouts": "Nethersproden",
  "block.minecraft.nether_wart": "Netherwaart",
  "block.minecraft.nether_wart_block": "Netherwaartenblok",
  "block.minecraft.netherite_block": "Netheritblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Mussikblok",
  "block.minecraft.oak_button": "Ekenholtknop",
  "block.minecraft.oak_door": "Ekendüör",
  "block.minecraft.oak_fence": "Ekenholttuun",
  "block.minecraft.oak_fence_gate": "Ekenholttuunpaort",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "Ekenbliäder",
  "block.minecraft.oak_log": "Ekenstam",
  "block.minecraft.oak_planks": "Ekenholtbreden",
  "block.minecraft.oak_pressure_plate": "Ekenholtdrukplaat",
  "block.minecraft.oak_sapling": "Ekensetter",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Ekenholtschild",
  "block.minecraft.oak_slab": "Ekenplaat",
  "block.minecraft.oak_stairs": "Ekenholttrapp",
  "block.minecraft.oak_trapdoor": "Ekenholtluuk",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "Ekenholtmüerschild",
  "block.minecraft.oak_wood": "Ekenholt",
  "block.minecraft.observer": "Waarnemer",
  "block.minecraft.obsidian": "Gnetersteen",
  "block.minecraft.ochre_froglight": "Ockerfarbenes Nebelscheinwerfer",
  "block.minecraft.ominous_banner": "Unheilvull Lappke",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Geelrootes Banner",
  "block.minecraft.orange_bed": "Geelrootes Bedd",
  "block.minecraft.orange_candle": "Geelrootes Lücht",
  "block.minecraft.orange_candle_cake": "Koken met geelrootem Lücht",
  "block.minecraft.orange_carpet": "Geelrooter Teppich",
  "block.minecraft.orange_concrete": "Geelrooter Beton",
  "block.minecraft.orange_concrete_powder": "Geelrooter Dröögbeton",
  "block.minecraft.orange_glazed_terracotta": "Geelroote glaseerte Keramik",
  "block.minecraft.orange_shulker_box": "Geelroote Shulker-Kist",
  "block.minecraft.orange_stained_glass": "Geelrootes Glas",
  "block.minecraft.orange_stained_glass_pane": "Geelroote Glasschiwe",
  "block.minecraft.orange_terracotta": "Geelroote Keramik",
  "block.minecraft.orange_tulip": "Geelroote Tulp",
  "block.minecraft.orange_wool": "Geelroote Wulle",
  "block.minecraft.oxeye_daisy": "Rüenblome",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Lütteriger Kopperblok",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Lütteriger snieden Kopperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Lütterige snieden Kopperplaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Lütterige snieden Koppertrapp",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Pakies",
  "block.minecraft.packed_mud": "Festmööt",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Bleekekenholtknop",
  "block.minecraft.pale_oak_door": "Bleekekenholtdöör",
  "block.minecraft.pale_oak_fence": "Bleekekenholttuun",
  "block.minecraft.pale_oak_fence_gate": "Bleekekenholttuunpaort",
  "block.minecraft.pale_oak_hanging_sign": "Hängeschild ut Bleekekenholt",
  "block.minecraft.pale_oak_leaves": "Bleekekenbliäder",
  "block.minecraft.pale_oak_log": "Bleekekenholtstam",
  "block.minecraft.pale_oak_planks": "Bleekekenholtbreden",
  "block.minecraft.pale_oak_pressure_plate": "Bleekekenholtdrukplaat",
  "block.minecraft.pale_oak_sapling": "Bleekekensetter",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Bleekekenholtschild",
  "block.minecraft.pale_oak_slab": "Bleekekenholtplaat",
  "block.minecraft.pale_oak_stairs": "Bleekekenholttrapp",
  "block.minecraft.pale_oak_trapdoor": "Bleekekenholtluuk",
  "block.minecraft.pale_oak_wall_hanging_sign": "Wandhängeschild ut Bleekekenholt",
  "block.minecraft.pale_oak_wall_sign": "Wandschild ut Bleekekenholt",
  "block.minecraft.pale_oak_wood": "Bleekekenholt",
  "block.minecraft.pearlescent_froglight": "Perlglanz-Nebelscheinwerfer",
  "block.minecraft.peony": "Pinkstrause",
  "block.minecraft.petrified_oak_slab": "Verstenert Ekenholtplaat",
  "block.minecraft.piglin_head": "Piglinkopp",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "Fienrootes Banner",
  "block.minecraft.pink_bed": "Fienrootes Bedd",
  "block.minecraft.pink_candle": "Fienrootes Lücht",
  "block.minecraft.pink_candle_cake": "Koken met fienrootem Lücht",
  "block.minecraft.pink_carpet": "Fienrooter Teppich",
  "block.minecraft.pink_concrete": "Fienrooter Beton",
  "block.minecraft.pink_concrete_powder": "Fienrooter Dröögbeton",
  "block.minecraft.pink_glazed_terracotta": "Fienroote glaseerte Keramik",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Fienroote Shulker-Kist",
  "block.minecraft.pink_stained_glass": "Fienrootes Glas",
  "block.minecraft.pink_stained_glass_pane": "Fienroote Glasschiwe",
  "block.minecraft.pink_terracotta": "Fienroote Keramik",
  "block.minecraft.pink_tulip": "Fienroote Tulp",
  "block.minecraft.pink_wool": "Fienroote Wulle",
  "block.minecraft.piston": "Stempel",
  "block.minecraft.piston_head": "Stempelkopp",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Speelerkopp",
  "block.minecraft.player_head.named": "Kopp vun %s",
  "block.minecraft.player_wall_head": "Speeler-Müerkopp",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitze Treppsteen",
  "block.minecraft.polished_andesite": "Poleerte Andesit",
  "block.minecraft.polished_andesite_slab": "Poleerte Andesitplaat",
  "block.minecraft.polished_andesite_stairs": "Poleerte Andesittrapp",
  "block.minecraft.polished_basalt": "Poleerter Basalt",
  "block.minecraft.polished_blackstone": "Poleerter Swatsteen",
  "block.minecraft.polished_blackstone_brick_slab": "Poleerte Swatsteentegelplaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Poleerte Swatsteentegeltrapp",
  "block.minecraft.polished_blackstone_brick_wall": "Poleerte Swatsteentegelmüer",
  "block.minecraft.polished_blackstone_bricks": "Poleerte Swatsteentegel",
  "block.minecraft.polished_blackstone_button": "Poleerter Swatsteenknop",
  "block.minecraft.polished_blackstone_pressure_plate": "Poleerte Swatsteendrukplaat",
  "block.minecraft.polished_blackstone_slab": "Poleerte Swatsteenplaat",
  "block.minecraft.polished_blackstone_stairs": "Poleerte Swatsteentrapp",
  "block.minecraft.polished_blackstone_wall": "Poleerte Swatsteenmüer",
  "block.minecraft.polished_deepslate": "Poleerte Deefschiever",
  "block.minecraft.polished_deepslate_slab": "Poleerte Deefschieverplaat",
  "block.minecraft.polished_deepslate_stairs": "Poleerte Deefschievertrapp",
  "block.minecraft.polished_deepslate_wall": "Poleerte Deefschievermüer",
  "block.minecraft.polished_diorite": "Poleerte Diorit",
  "block.minecraft.polished_diorite_slab": "Poleerte Dioritplaat",
  "block.minecraft.polished_diorite_stairs": "Poleerte Diorittrapp",
  "block.minecraft.polished_granite": "Poleerte Granit",
  "block.minecraft.polished_granite_slab": "Poleerte Granitplaat",
  "block.minecraft.polished_granite_stairs": "Poleerte Granittrapp",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Maon",
  "block.minecraft.potatoes": "Kartuffeln",
  "block.minecraft.potted_acacia_sapling": "Inpottede Akatsiensetter",
  "block.minecraft.potted_allium": "Inpottede Steernlook",
  "block.minecraft.potted_azalea_bush": "Inpottede Azalee",
  "block.minecraft.potted_azure_bluet": "Inpottede blao Porslainenstäänken",
  "block.minecraft.potted_bamboo": "Inpottede Bambus",
  "block.minecraft.potted_birch_sapling": "Inpottede Biäkensetter",
  "block.minecraft.potted_blue_orchid": "Inpottede blaoe Orchidee",
  "block.minecraft.potted_brown_mushroom": "Inpottede bruune Poggenstool",
  "block.minecraft.potted_cactus": "Inpottede Kaktus",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Inpottede Kornblööm",
  "block.minecraft.potted_crimson_fungus": "Inpottede Purpurootpilz",
  "block.minecraft.potted_crimson_roots": "Inpottede Purpurootwörteln",
  "block.minecraft.potted_dandelion": "Inpottede Hunnblööm",
  "block.minecraft.potted_dark_oak_sapling": "Inpottede Swatekensetter",
  "block.minecraft.potted_dead_bush": "Inpottede dooter Busk",
  "block.minecraft.potted_fern": "Inpottede Faon",
  "block.minecraft.potted_flowering_azalea_bush": "Inpottede blöhende Azalee",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Inpottede Oorwooldsetter",
  "block.minecraft.potted_lily_of_the_valley": "Inpottede Maiklockje",
  "block.minecraft.potted_mangrove_propagule": "Topf-Mangroven-Vermehrung",
  "block.minecraft.potted_oak_sapling": "Inpottede Ekensetter",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Inpottede geelroote Tulp",
  "block.minecraft.potted_oxeye_daisy": "Inpottede Margerite",
  "block.minecraft.potted_pale_oak_sapling": "Inpottede Bleekekensetter",
  "block.minecraft.potted_pink_tulip": "Inpottede fienroote Tulp",
  "block.minecraft.potted_poppy": "Inpottede Maon",
  "block.minecraft.potted_red_mushroom": "Inpottede roote Poggenstool",
  "block.minecraft.potted_red_tulip": "Inpottede roote Tulp",
  "block.minecraft.potted_spruce_sapling": "Inpottede Füchtensetter",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Inpottede Wierpilz",
  "block.minecraft.potted_warped_roots": "Inpottede Wierwörteln",
  "block.minecraft.potted_white_tulip": "Inpottede witte Tulp",
  "block.minecraft.potted_wither_rose": "Inpottede Wither-Roos",
  "block.minecraft.powder_snow": "Pulversnee",
  "block.minecraft.powder_snow_cauldron": "Pulversneeketel",
  "block.minecraft.powered_rail": "Stroomschine",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Prismarientegelplaat",
  "block.minecraft.prismarine_brick_stairs": "Prismarientegeltrapp",
  "block.minecraft.prismarine_bricks": "Prismarientegel",
  "block.minecraft.prismarine_slab": "Prismarienplaat",
  "block.minecraft.prismarine_stairs": "Prismarientrapp",
  "block.minecraft.prismarine_wall": "Prismarienmüer",
  "block.minecraft.pumpkin": "Kävers",
  "block.minecraft.pumpkin_stem": "Käversplant",
  "block.minecraft.purple_banner": "Vigelettes Banner",
  "block.minecraft.purple_bed": "Vigelettes Bedd",
  "block.minecraft.purple_candle": "Vigelettes Lücht",
  "block.minecraft.purple_candle_cake": "Koken met vigelettem Lücht",
  "block.minecraft.purple_carpet": "Vigeletter Teppich",
  "block.minecraft.purple_concrete": "Vigeletter Beton",
  "block.minecraft.purple_concrete_powder": "Vigeletter Dröögbeton",
  "block.minecraft.purple_glazed_terracotta": "Vigelette glaseerte Keramik",
  "block.minecraft.purple_shulker_box": "Vigelette Shulker-Kist",
  "block.minecraft.purple_stained_glass": "Vigelettes Glas",
  "block.minecraft.purple_stained_glass_pane": "Vigelette Glasschiwe",
  "block.minecraft.purple_terracotta": "Vigelette Keramik",
  "block.minecraft.purple_wool": "Vigelette Wulle",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpursüle",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpurtrapp",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwartstegel",
  "block.minecraft.quartz_pillar": "Kwartssüle",
  "block.minecraft.quartz_slab": "Kwartsplaat",
  "block.minecraft.quartz_stairs": "Kwartstrapp",
  "block.minecraft.rail": "Schine",
  "block.minecraft.raw_copper_block": "Rauhkopperblok",
  "block.minecraft.raw_gold_block": "Rauhgüldblok",
  "block.minecraft.raw_iron_block": "Rauhisenblok",
  "block.minecraft.red_banner": "Rootes Banner",
  "block.minecraft.red_bed": "Rootes Bedd",
  "block.minecraft.red_candle": "Rootes Lücht",
  "block.minecraft.red_candle_cake": "Koken met rootem Lücht",
  "block.minecraft.red_carpet": "Rooter Teppich",
  "block.minecraft.red_concrete": "Rooter Beton",
  "block.minecraft.red_concrete_powder": "Rooter Dröögbeton",
  "block.minecraft.red_glazed_terracotta": "Roote glaseerte Keramik",
  "block.minecraft.red_mushroom": "Roote Poggenstool",
  "block.minecraft.red_mushroom_block": "Roote Poggenstoolblok",
  "block.minecraft.red_nether_brick_slab": "Roote Nethertegelplaat",
  "block.minecraft.red_nether_brick_stairs": "Roote Nethertegeltrapp",
  "block.minecraft.red_nether_brick_wall": "Roote Nethertegelmüer",
  "block.minecraft.red_nether_bricks": "Roote Nethertegel",
  "block.minecraft.red_sand": "Rooter Sand",
  "block.minecraft.red_sandstone": "Rooter Sandsteen",
  "block.minecraft.red_sandstone_slab": "Roote Sandsteenplaat",
  "block.minecraft.red_sandstone_stairs": "Roote Sandsteentrapp",
  "block.minecraft.red_sandstone_wall": "Roote Sandsteenmüer",
  "block.minecraft.red_shulker_box": "Roote Shulker-Kist",
  "block.minecraft.red_stained_glass": "Rootes Glas",
  "block.minecraft.red_stained_glass_pane": "Roote Glasschiwe",
  "block.minecraft.red_terracotta": "Roote Keramik",
  "block.minecraft.red_tulip": "Roote Tulp",
  "block.minecraft.red_wool": "Roote Wulle",
  "block.minecraft.redstone_block": "Redstone-Blok",
  "block.minecraft.redstone_lamp": "Redstone-Lamp",
  "block.minecraft.redstone_ore": "Redstone-Ärts",
  "block.minecraft.redstone_torch": "Redstone-Lunt",
  "block.minecraft.redstone_wall_torch": "Redstone-Müerlunt",
  "block.minecraft.redstone_wire": "Redstone-Draoht",
  "block.minecraft.reinforced_deepslate": "Verstärkter tiefer Schiefer",
  "block.minecraft.repeater": "Redstone-Verstarker",
  "block.minecraft.repeating_command_block": "Wedderhal-Befiälsblok",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Seelanker",
  "block.minecraft.rooted_dirt": "Wuddeläer",
  "block.minecraft.rose_bush": "Rausenbusk",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandsteen",
  "block.minecraft.sandstone_slab": "Sandsteenplaat",
  "block.minecraft.sandstone_stairs": "Sandsteentrapp",
  "block.minecraft.sandstone_wall": "Sandsteenmüer",
  "block.minecraft.scaffolding": "Gerüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk Kreischer",
  "block.minecraft.sculk_vein": "Schädelvene",
  "block.minecraft.sea_lantern": "Selatüchte",
  "block.minecraft.sea_pickle": "Seegurk",
  "block.minecraft.seagrass": "Kroos",
  "block.minecraft.set_spawn": "Wierinstiegspunkt sett",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Poggenstoollücht",
  "block.minecraft.shulker_box": "Shulker-Kist",
  "block.minecraft.skeleton_skull": "Skeletkopp",
  "block.minecraft.skeleton_wall_skull": "Skelet-Müerkopp",
  "block.minecraft.slime_block": "Sliemblok",
  "block.minecraft.small_amethyst_bud": "Lütte Amethystknosknupp",
  "block.minecraft.small_dripleaf": "Lütt Treppblatt",
  "block.minecraft.smithing_table": "Smitgtafel",
  "block.minecraft.smoker": "Rökelaven",
  "block.minecraft.smooth_basalt": "Glatter Basalt",
  "block.minecraft.smooth_quartz": "Glatter Kwartsblok",
  "block.minecraft.smooth_quartz_slab": "Glatte Kwartsplaat",
  "block.minecraft.smooth_quartz_stairs": "Glatte Kwartstrapp",
  "block.minecraft.smooth_red_sandstone": "Glatter rooter Sandsteen",
  "block.minecraft.smooth_red_sandstone_slab": "Glatte roote Sandsteenplaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatte roote Sandsteentrapp",
  "block.minecraft.smooth_sandstone": "Glatter Sandsteen",
  "block.minecraft.smooth_sandstone_slab": "Glatte Sandsteenplaat",
  "block.minecraft.smooth_sandstone_stairs": "Glatte Sandsteentrapp",
  "block.minecraft.smooth_stone": "Glatter Steen",
  "block.minecraft.smooth_stone_slab": "Glatte Steenplaat",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snee",
  "block.minecraft.snow_block": "Sneeblok",
  "block.minecraft.soul_campfire": "Siälenloagafia",
  "block.minecraft.soul_fire": "Siälenfüer",
  "block.minecraft.soul_lantern": "Siälenlatern",
  "block.minecraft.soul_sand": "Siälensand",
  "block.minecraft.soul_soil": "Siälenäer",
  "block.minecraft.soul_torch": "Siälenlunt",
  "block.minecraft.soul_wall_torch": "Siälenmüerlunt",
  "block.minecraft.spawn.not_valid": "Du hest keen Bedd un keen opladenen Seelanker, of dien Wierinstieg wurr blokeert",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Swamm",
  "block.minecraft.spore_blossom": "Sporenblööt",
  "block.minecraft.spruce_button": "Füchtenholtknop",
  "block.minecraft.spruce_door": "Füchtendüör",
  "block.minecraft.spruce_fence": "Füchtenholttuun",
  "block.minecraft.spruce_fence_gate": "Füchtenholttuunpaort",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "Füchtennadeln",
  "block.minecraft.spruce_log": "Füchtenstam",
  "block.minecraft.spruce_planks": "Füchtenholtbreden",
  "block.minecraft.spruce_pressure_plate": "Füchtenholtdrukplaat",
  "block.minecraft.spruce_sapling": "Füchtensetter",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Füchtenholtschild",
  "block.minecraft.spruce_slab": "Füchtenholtplaat",
  "block.minecraft.spruce_stairs": "Füchtenholttrapp",
  "block.minecraft.spruce_trapdoor": "Füchtenholtluuk",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "Füchtenholtmüerschild",
  "block.minecraft.spruce_wood": "Füchtenholt",
  "block.minecraft.sticky_piston": "Kliëwriger Stempel",
  "block.minecraft.stone": "Steen",
  "block.minecraft.stone_brick_slab": "Steentegelplaat",
  "block.minecraft.stone_brick_stairs": "Steentegeltrapp",
  "block.minecraft.stone_brick_wall": "Steentegelmüer",
  "block.minecraft.stone_bricks": "Steentegels",
  "block.minecraft.stone_button": "Steenknop",
  "block.minecraft.stone_pressure_plate": "Steendrükplaat",
  "block.minecraft.stone_slab": "Steenplaat",
  "block.minecraft.stone_stairs": "Steentrapp",
  "block.minecraft.stonecutter": "Steensaag",
  "block.minecraft.stripped_acacia_log": "Entbarked Akatsienstam",
  "block.minecraft.stripped_acacia_wood": "Entbarked Akatsienholt",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Entbarked Biäkenstam",
  "block.minecraft.stripped_birch_wood": "Entbarked Biäkenholt",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Entbarked Purpuroothyphen",
  "block.minecraft.stripped_crimson_stem": "Entbarked Purpurootstam",
  "block.minecraft.stripped_dark_oak_log": "Entbarked Swatekenstam",
  "block.minecraft.stripped_dark_oak_wood": "Entbarked Swatekenholt",
  "block.minecraft.stripped_jungle_log": "Entbarked Oorwooldstam",
  "block.minecraft.stripped_jungle_wood": "Entbarked Oorwooldholt",
  "block.minecraft.stripped_mangrove_log": "Abgestreifter Mangrovenstamm",
  "block.minecraft.stripped_mangrove_wood": "Abgestreiftes Mangrovenholz",
  "block.minecraft.stripped_oak_log": "Entbarked Ekenstam",
  "block.minecraft.stripped_oak_wood": "Entbarked Ekenholt",
  "block.minecraft.stripped_pale_oak_log": "Entbarked Bleekekenholtstam",
  "block.minecraft.stripped_pale_oak_wood": "Entbarked Bleekekenholt",
  "block.minecraft.stripped_spruce_log": "Entbarked Füchtenstam",
  "block.minecraft.stripped_spruce_wood": "Entbarked Füchtenholt",
  "block.minecraft.stripped_warped_hyphae": "Entbarked Wierhyphen",
  "block.minecraft.stripped_warped_stem": "Entbarked Wierstam",
  "block.minecraft.structure_block": "Bauwiärksblok",
  "block.minecraft.structure_void": "Bauwiärksleege",
  "block.minecraft.sugar_cane": "Suckerrör",
  "block.minecraft.sunflower": "Sünnenbloom",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Söötbejestruuk",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Hooget Gras",
  "block.minecraft.tall_seagrass": "Hooges Kroos",
  "block.minecraft.target": "Teelblok",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Tönt Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Lunt",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Redstone-Truh",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Strumpeldraod",
  "block.minecraft.tripwire_hook": "Haken",
  "block.minecraft.tube_coral": "Röhrkorall",
  "block.minecraft.tube_coral_block": "Röhrkorallblok",
  "block.minecraft.tube_coral_fan": "Röhrkorallwaier",
  "block.minecraft.tube_coral_wall_fan": "Röhrkorallmüerwaier",
  "block.minecraft.tuff": "Tuffsteen",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Skildpadai",
  "block.minecraft.twisting_vines": "Zwirbelranken",
  "block.minecraft.twisting_vines_plant": "Zwirbelrankenplant",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Grünes Nebellicht",
  "block.minecraft.vine": "Ranken",
  "block.minecraft.void_air": "Leegenluft",
  "block.minecraft.wall_torch": "Müerlunt",
  "block.minecraft.warped_button": "Wierknop",
  "block.minecraft.warped_door": "Wierdüör",
  "block.minecraft.warped_fence": "Wiertuun",
  "block.minecraft.warped_fence_gate": "Wiertuunpaort",
  "block.minecraft.warped_fungus": "Wierpilz",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Sign",
  "block.minecraft.warped_hyphae": "Wierhyphen",
  "block.minecraft.warped_nylium": "Wier-Nezel",
  "block.minecraft.warped_planks": "Wierbreden",
  "block.minecraft.warped_pressure_plate": "Wierdrukplaat",
  "block.minecraft.warped_roots": "Wierwörteln",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Wierschild",
  "block.minecraft.warped_slab": "Wierplaat",
  "block.minecraft.warped_stairs": "Wiertrapp",
  "block.minecraft.warped_stem": "Wierstam",
  "block.minecraft.warped_trapdoor": "Wierluuk",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Sign",
  "block.minecraft.warped_wall_sign": "Wiermüerschild",
  "block.minecraft.warped_wart_block": "Wierwaartenblok",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Waterketel",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Gewaaker Kopperblok",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Gewaaker snieden Kopperblok",
  "block.minecraft.waxed_cut_copper_slab": "Gewaake snieden Kopperplaat",
  "block.minecraft.waxed_cut_copper_stairs": "Gewaake snieden Koppertrapp",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Gewaaker anlopt Kopperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Gewaaker anlopt snieden Kopperblok",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewaake anlopt snieden Kopperplaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gewaake anlopt snieden Koppertrapp",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Gewaaker lütteriger Kopperblok",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewaaker lütteriger snieden Kopperblok",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewaake lütterige snieden Kopperplaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gewaake lütterige snieden Koppertrapp",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Gewaaker verwitter Kopperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Gewaaker verwitter snieden Kopperblok",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewaake verwitter snieden Kopperplaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gewaake verwitter snieden Koppertrapp",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Verwitter Kopperblok",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Verwitter snieden Kopperblok",
  "block.minecraft.weathered_cut_copper_slab": "Verwitter snieden Kopperplaat",
  "block.minecraft.weathered_cut_copper_stairs": "Verwitter snieden Koppertrapp",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Truerranken",
  "block.minecraft.weeping_vines_plant": "Truerrankenplant",
  "block.minecraft.wet_sponge": "Natter Swamm",
  "block.minecraft.wheat": "Waitenplant",
  "block.minecraft.white_banner": "Wittes Banner",
  "block.minecraft.white_bed": "Wittes Bedd",
  "block.minecraft.white_candle": "Wittes Lücht",
  "block.minecraft.white_candle_cake": "Koken met wittem Lücht",
  "block.minecraft.white_carpet": "Witte Teppich",
  "block.minecraft.white_concrete": "Witter Beton",
  "block.minecraft.white_concrete_powder": "Witter Dröögbeton",
  "block.minecraft.white_glazed_terracotta": "Witte glaseerte Keramik",
  "block.minecraft.white_shulker_box": "Witte Shulker-Kist",
  "block.minecraft.white_stained_glass": "Wit Glas",
  "block.minecraft.white_stained_glass_pane": "Witte Glasschiwe",
  "block.minecraft.white_terracotta": "Witte Keramik",
  "block.minecraft.white_tulip": "Witte Tulp",
  "block.minecraft.white_wool": "Witte Wulle",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Wither-Roos",
  "block.minecraft.wither_skeleton_skull": "Witherskeletkopp",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelet-Müerkopp",
  "block.minecraft.yellow_banner": "Geeles Banner",
  "block.minecraft.yellow_bed": "Geeles Bedd",
  "block.minecraft.yellow_candle": "Geeles Lücht",
  "block.minecraft.yellow_candle_cake": "Koken met geelem Lücht",
  "block.minecraft.yellow_carpet": "Geeler Teppich",
  "block.minecraft.yellow_concrete": "Geeler Beton",
  "block.minecraft.yellow_concrete_powder": "Geeler Dröögbeton",
  "block.minecraft.yellow_glazed_terracotta": "Geele glaseerte Keramik",
  "block.minecraft.yellow_shulker_box": "Geele Shulker-Kist",
  "block.minecraft.yellow_stained_glass": "Geeles Glas",
  "block.minecraft.yellow_stained_glass_pane": "Geele Glasschiwe",
  "block.minecraft.yellow_terracotta": "Geele Keramik",
  "block.minecraft.yellow_wool": "Geele Wulle",
  "block.minecraft.zombie_head": "Zombiekopp",
  "block.minecraft.zombie_wall_head": "Zombie-Müerkopp",
  "item.minecraft.acacia_boat": "Akatsienholtbööd",
  "item.minecraft.acacia_chest_boat": "Akatsienholtbööd met Truh",
  "item.minecraft.allay_spawn_egg": "Laichei zerstreuen",
  "item.minecraft.amethyst_shard": "Amethystsplaot",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Rüststänner",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Piel",
  "item.minecraft.axolotl_bucket": "Axolotlemmer",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ai",
  "item.minecraft.baked_potato": "Ovendkartuffel",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Fleddermuus-Spawn-Ai",
  "item.minecraft.bee_spawn_egg": "Immen-Spawn-Ai",
  "item.minecraft.beef": "Rauhet Rindfleesk",
  "item.minecraft.beetroot": "Roote Beet",
  "item.minecraft.beetroot_seeds": "Roote-Beet-Säöte",
  "item.minecraft.beetroot_soup": "Borscht",
  "item.minecraft.birch_boat": "Biäkenholtbööd",
  "item.minecraft.birch_chest_boat": "Biäkenholtbööd met Truh",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Swatte Farve",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Lohenstoff",
  "item.minecraft.blaze_rod": "Lohenroot",
  "item.minecraft.blaze_spawn_egg": "Lohen-Spawn-Ai",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blaoe Farve",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Been",
  "item.minecraft.bone_meal": "Beenmiäl",
  "item.minecraft.book": "Book",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Buogen",
  "item.minecraft.bowl": "Nap",
  "item.minecraft.bread": "Braud",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Tegel",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Bruune Farve",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Emmer",
  "item.minecraft.bundle": "Bünnel",
  "item.minecraft.bundle.empty": "Leeg",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "Wuddel",
  "item.minecraft.carrot_on_a_stick": "Wuddelroot",
  "item.minecraft.cat_spawn_egg": "Katten-Spawn-Ai",
  "item.minecraft.cauldron": "Ketel",
  "item.minecraft.cave_spider_spawn_egg": "Hüölenspenn-Spawn-Ai",
  "item.minecraft.chainmail_boots": "Käddenstiëwels",
  "item.minecraft.chainmail_chestplate": "Käddenbuorstplaat",
  "item.minecraft.chainmail_helmet": "Käddenhaavk",
  "item.minecraft.chainmail_leggings": "Käddenbükse",
  "item.minecraft.charcoal": "Holtkuole",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "Truhkaor",
  "item.minecraft.chicken": "Rauhet Hoönken",
  "item.minecraft.chicken_spawn_egg": "Hohn-Spawn-Ai",
  "item.minecraft.chorus_fruit": "Chorusfrücht",
  "item.minecraft.clay_ball": "Klaibal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Kuole",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Kakaubaunen",
  "item.minecraft.cod": "Rauher Kabeljauw",
  "item.minecraft.cod_bucket": "Kabeljauwemmer",
  "item.minecraft.cod_spawn_egg": "Kabeljauw-Spawn-Ai",
  "item.minecraft.command_block_minecart": "Befiälskaor",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Steik",
  "item.minecraft.cooked_chicken": "Brodten Hoönken",
  "item.minecraft.cooked_cod": "Brodten Kabeljauw",
  "item.minecraft.cooked_mutton": "Brodten Lobbenfleesk",
  "item.minecraft.cooked_porkchop": "Brodten Swienefleesk",
  "item.minecraft.cooked_rabbit": "Brodten Kanickel",
  "item.minecraft.cooked_salmon": "Brodten Las",
  "item.minecraft.cookie": "Keeks",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Kopperbarren",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kau-Spawn-Ai",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Lappkevörlaag",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ai",
  "item.minecraft.crossbow": "Armborst",
  "item.minecraft.crossbow.projectile": "Hagel:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Blaogrööne Farve",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Swatekenholtbööd",
  "item.minecraft.dark_oak_chest_boat": "Swatekenholtbööd met Truh",
  "item.minecraft.debug_stick": "Debugstok",
  "item.minecraft.debug_stick.empty": "%s hett keen Blokstahn",
  "item.minecraft.debug_stick.select": "\"%s\" utwählt (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" is nu %s",
  "item.minecraft.diamond": "Demant",
  "item.minecraft.diamond_axe": "Demantext",
  "item.minecraft.diamond_boots": "Demantstiëwels",
  "item.minecraft.diamond_chestplate": "Demantbuorstplaat",
  "item.minecraft.diamond_helmet": "Demanthelm",
  "item.minecraft.diamond_hoe": "Demanthaak",
  "item.minecraft.diamond_horse_armor": "Demanter Peerderüst",
  "item.minecraft.diamond_leggings": "Demantbükse",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Demantbicke",
  "item.minecraft.diamond_shovel": "Demantschöfel",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Demantswiärt",
  "item.minecraft.disc_fragment_5": "Scheibenfragment",
  "item.minecraft.disc_fragment_5.desc": "Musik-CD - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ai",
  "item.minecraft.donkey_spawn_egg": "Esel-Spawn-Ai",
  "item.minecraft.dragon_breath": "Draakaam",
  "item.minecraft.dried_kelp": "Dröögter Tang",
  "item.minecraft.drowned_spawn_egg": "Vordrunkenen-Spawn-Ai",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echoscherbe",
  "item.minecraft.egg": "Ai",
  "item.minecraft.elder_guardian_spawn_egg": "Grooter-Wachter-Spawn-Ai",
  "item.minecraft.elytra": "Elytren",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Betövert Book",
  "item.minecraft.enchanted_golden_apple": "Betöverter güllener Appel",
  "item.minecraft.end_crystal": "Endkristaal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Enderoog",
  "item.minecraft.ender_pearl": "Enderparrel",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ai",
  "item.minecraft.endermite_spawn_egg": "Endermiten-Spawn-Ai",
  "item.minecraft.evoker_spawn_egg": "Magister-Spawn-Ai",
  "item.minecraft.experience_bottle": "Erfaorungsbuddel",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Fiäder",
  "item.minecraft.fermented_spider_eye": "Fermentiertes Spennauge",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Kaat",
  "item.minecraft.fire_charge": "Füerbal",
  "item.minecraft.firework_rocket": "Füerwiärksrakeet",
  "item.minecraft.firework_rocket.flight": "Floogduer:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Füerwiärksstään",
  "item.minecraft.firework_star.black": "Swat",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Bruun",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Blaogröön",
  "item.minecraft.firework_star.fade_to": "Övergang to",
  "item.minecraft.firework_star.flicker": "Glämmer",
  "item.minecraft.firework_star.gray": "Grao",
  "item.minecraft.firework_star.green": "Gröön",
  "item.minecraft.firework_star.light_blue": "Lechtblao",
  "item.minecraft.firework_star.light_gray": "Gries",
  "item.minecraft.firework_star.lime": "Lechtgröön",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Geelroot",
  "item.minecraft.firework_star.pink": "Fienroot",
  "item.minecraft.firework_star.purple": "Vigelett",
  "item.minecraft.firework_star.red": "Root",
  "item.minecraft.firework_star.shape": "Unkunnige Fuom",
  "item.minecraft.firework_star.shape.burst": "Eksplosiaun",
  "item.minecraft.firework_star.shape.creeper": "Creeperfüömig",
  "item.minecraft.firework_star.shape.large_ball": "Grauter Bal",
  "item.minecraft.firework_star.shape.small_ball": "Lütt Kugel",
  "item.minecraft.firework_star.shape.star": "Stäänfüömig",
  "item.minecraft.firework_star.trail": "Stiärt",
  "item.minecraft.firework_star.white": "Witt",
  "item.minecraft.firework_star.yellow": "Geel",
  "item.minecraft.fishing_rod": "Angelruut",
  "item.minecraft.flint": "Füersteen",
  "item.minecraft.flint_and_steel": "Füertüüg",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Blööm",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Blöömpott",
  "item.minecraft.fox_spawn_egg": "Voss-Spawn-Ai",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Froschlaich-Ei",
  "item.minecraft.furnace_minecart": "Driewkaor",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ai",
  "item.minecraft.ghast_tear": "Ghasttraan",
  "item.minecraft.glass_bottle": "Glasbuddel",
  "item.minecraft.glistering_melon_slice": "Glinsteren Meloonenschiev",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Eer",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Lüchtbeern",
  "item.minecraft.glow_ink_sac": "Lüchtenksak",
  "item.minecraft.glow_item_frame": "Lüchtraam",
  "item.minecraft.glow_squid_spawn_egg": "Lüchtenktfisk-Spawn-Ai",
  "item.minecraft.glowstone_dust": "Glowstonepulwer",
  "item.minecraft.goat_horn": "Ziegenhoorn",
  "item.minecraft.goat_spawn_egg": "Ziegen-Spawn-Ai",
  "item.minecraft.gold_ingot": "Güldbarren",
  "item.minecraft.gold_nugget": "Güldklump",
  "item.minecraft.golden_apple": "Güllener Appel",
  "item.minecraft.golden_axe": "Güldäkse",
  "item.minecraft.golden_boots": "Güldstiëwels",
  "item.minecraft.golden_carrot": "Güllene Wuddel",
  "item.minecraft.golden_chestplate": "Güldbuorstplaat",
  "item.minecraft.golden_helmet": "Güldhelm",
  "item.minecraft.golden_hoe": "Güldhak",
  "item.minecraft.golden_horse_armor": "Güllene Peerderüst",
  "item.minecraft.golden_leggings": "Güldbükse",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Güldbicke",
  "item.minecraft.golden_shovel": "Güldschöfel",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Güldswiärt",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Graoe Farve",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Grööne Farve",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Wachter-Spawn-Ai",
  "item.minecraft.gunpowder": "Schaitpulwer",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Hart vun de See",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ai",
  "item.minecraft.honey_bottle": "Hönnigbuddel",
  "item.minecraft.honeycomb": "Hönnigwaar",
  "item.minecraft.hopper_minecart": "Trächterkaor",
  "item.minecraft.horse_spawn_egg": "Peerde-Spawn-Ai",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Wüüstenzombie-Spawn-Ai",
  "item.minecraft.ink_sac": "Enksak",
  "item.minecraft.iron_axe": "Isenäkse",
  "item.minecraft.iron_boots": "Isenstiëwels",
  "item.minecraft.iron_chestplate": "Isenbuorstplaat",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Isenhelm",
  "item.minecraft.iron_hoe": "Isenhak",
  "item.minecraft.iron_horse_armor": "Isderne Peerderüst",
  "item.minecraft.iron_ingot": "Isenbarren",
  "item.minecraft.iron_leggings": "Isenbükse",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Isenklump",
  "item.minecraft.iron_pickaxe": "Isenbicke",
  "item.minecraft.iron_shovel": "Isenschöfel",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Isenswiärt",
  "item.minecraft.item_frame": "Raam",
  "item.minecraft.jungle_boat": "Oorwooldholtbööd",
  "item.minecraft.jungle_chest_boat": "Oorwooldholtbööd met Truh",
  "item.minecraft.knowledge_book": "Book vun Weten",
  "item.minecraft.lapis_lazuli": "Lapislatsuli",
  "item.minecraft.lava_bucket": "Lawaemmer",
  "item.minecraft.lead": "Line",
  "item.minecraft.leather": "Liäder",
  "item.minecraft.leather_boots": "Liäderstiëwels",
  "item.minecraft.leather_chestplate": "Liäderharnsch",
  "item.minecraft.leather_helmet": "Liäderkapp",
  "item.minecraft.leather_horse_armor": "Liäderne Peerderüst",
  "item.minecraft.leather_leggings": "Liäderbükse",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Lechtblaoe Farve",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Griese Farve",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Lechtgrööne Farve",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Wieldrank",
  "item.minecraft.lingering_potion.effect.awkward": "Raarer Wieldrank",
  "item.minecraft.lingering_potion.effect.empty": "Neet braubarerer Wieldrank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Wieldrank de Förresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Wieldrank de Schaas",
  "item.minecraft.lingering_potion.effect.healing": "Wieldrank de Betern",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Wieldrank de Unsichtborkeid",
  "item.minecraft.lingering_potion.effect.leaping": "Wieldrank de Sprungkracht",
  "item.minecraft.lingering_potion.effect.levitation": "Wieldrank de Swevekracht",
  "item.minecraft.lingering_potion.effect.luck": "Wieldrank de Glük",
  "item.minecraft.lingering_potion.effect.mundane": "Gewöhnelker Wieldrank",
  "item.minecraft.lingering_potion.effect.night_vision": "Wieldrank de Nachtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Wieldrank de Vergiftung",
  "item.minecraft.lingering_potion.effect.regeneration": "Wieldrank de Regeneratioon",
  "item.minecraft.lingering_potion.effect.slow_falling": "Wieldrank de sachte Val",
  "item.minecraft.lingering_potion.effect.slowness": "Wieldrank de Langsaamkeid",
  "item.minecraft.lingering_potion.effect.strength": "Wieldrank de Starkte",
  "item.minecraft.lingering_potion.effect.swiftness": "Wieldrank de Gauigkait",
  "item.minecraft.lingering_potion.effect.thick": "Lobberger Wieldrank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Wieldrank vun ’n Skildpadmeester",
  "item.minecraft.lingering_potion.effect.water": "Wielene Waterbuddel",
  "item.minecraft.lingering_potion.effect.water_breathing": "Wieldrank de Unnerwateratmung",
  "item.minecraft.lingering_potion.effect.weakness": "Wieldrank de Swackte",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ai",
  "item.minecraft.lodestone_compass": "Leitsteen-Kompas",
  "item.minecraft.mace": "Streitkolben",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta Farve",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magmakreem",
  "item.minecraft.magma_cube_spawn_egg": "Magmawörpel-Spawn-Ai",
  "item.minecraft.mangrove_boat": "Mangrovenboot",
  "item.minecraft.mangrove_chest_boat": "Mangrovenboot mit Truhe",
  "item.minecraft.map": "Leege Kaat",
  "item.minecraft.melon_seeds": "Meloonsäöte",
  "item.minecraft.melon_slice": "Meloonschieve",
  "item.minecraft.milk_bucket": "Melkemmer",
  "item.minecraft.minecart": "Kipkaor",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Wapen",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ai",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Muuldier-Spawn-Ai",
  "item.minecraft.mushroom_stew": "Poggenstoolsup",
  "item.minecraft.music_disc_11": "Schalplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schalplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Disc",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schalplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schalplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schalplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schalplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schalplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Spöölkasten)",
  "item.minecraft.music_disc_far": "Schalplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schalplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schalplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schalplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schalplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schalplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schalplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schalplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schalplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schalplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schalplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rauhet Lobbenfleesk",
  "item.minecraft.name_tag": "Naamschild",
  "item.minecraft.nautilus_shell": "Nautilusschaal",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nethertegel",
  "item.minecraft.nether_star": "Nethersteern",
  "item.minecraft.nether_wart": "Netherwaart",
  "item.minecraft.netherite_axe": "Netheritäkse",
  "item.minecraft.netherite_boots": "Netheritstiëwels",
  "item.minecraft.netherite_chestplate": "Netheritbuorstplaat",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netherithak",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netheritbarren",
  "item.minecraft.netherite_leggings": "Netheritbükse",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheritbicke",
  "item.minecraft.netherite_scrap": "Netheritplaten",
  "item.minecraft.netherite_shovel": "Netheritschöfel",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netheritswiärt",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Ekenholtbööd",
  "item.minecraft.oak_chest_boat": "Ekenholtbööd met Truh",
  "item.minecraft.ocelot_spawn_egg": "Otselot-Spawn-Ai",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Geelroote Farve",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Beld",
  "item.minecraft.pale_oak_boat": "Bleekekenholtbööd",
  "item.minecraft.pale_oak_chest_boat": "Bleekekenholtbööd met Kiste",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ai",
  "item.minecraft.paper": "Papeer",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Papagoien-Spawn-Ai",
  "item.minecraft.phantom_membrane": "Fantoomhuut",
  "item.minecraft.phantom_spawn_egg": "Fantoom-Spawn-Ai",
  "item.minecraft.pig_spawn_egg": "Swiene-Spawn-Ai",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Schnut",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbaaren-Spawn-Ai",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ai",
  "item.minecraft.pillager_spawn_egg": "Plünner-Spawn-Ai",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Fienroote Farve",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Giftege Kartuffel",
  "item.minecraft.polar_bear_spawn_egg": "Iesbaaren-Spawn-Ai",
  "item.minecraft.popped_chorus_fruit": "Platzt Chorusfrücht",
  "item.minecraft.porkchop": "Rauhet Swienefleesk",
  "item.minecraft.potato": "Kartuffel",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Wunnerlik Drank",
  "item.minecraft.potion.effect.empty": "Nich broebar Drank",
  "item.minecraft.potion.effect.fire_resistance": "Drank de Förresistenz",
  "item.minecraft.potion.effect.harming": "Drank de Schaas",
  "item.minecraft.potion.effect.healing": "Drank de Betern",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Drank de Unsichtborkeid",
  "item.minecraft.potion.effect.leaping": "Drank de Sprungkracht",
  "item.minecraft.potion.effect.levitation": "Drank de Swevekracht",
  "item.minecraft.potion.effect.luck": "Drank de Glük",
  "item.minecraft.potion.effect.mundane": "Gewöhnelk Drank",
  "item.minecraft.potion.effect.night_vision": "Drank de Nachtsicht",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Drank de Vergiften",
  "item.minecraft.potion.effect.regeneration": "Drank de Regeneratioon",
  "item.minecraft.potion.effect.slow_falling": "Drank de sachte Val",
  "item.minecraft.potion.effect.slowness": "Drank de Langsaamkeid",
  "item.minecraft.potion.effect.strength": "Drank de Starkte",
  "item.minecraft.potion.effect.swiftness": "Drank de Gauigkait",
  "item.minecraft.potion.effect.thick": "Lobbig Drank",
  "item.minecraft.potion.effect.turtle_master": "Drank vun ’n Skildpadmeester",
  "item.minecraft.potion.effect.water": "Waterbuddel",
  "item.minecraft.potion.effect.water_breathing": "Drank de Unnerwateratmung",
  "item.minecraft.potion.effect.weakness": "Drank de Swackte",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Pulversneeemmer",
  "item.minecraft.prismarine_crystals": "Prismarienkristallen",
  "item.minecraft.prismarine_shard": "Prismariensplaot",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Kugelfisk",
  "item.minecraft.pufferfish_bucket": "Kugelfiskemmer",
  "item.minecraft.pufferfish_spawn_egg": "Kugelfisk-Spawn-Ai",
  "item.minecraft.pumpkin_pie": "Käverskoken",
  "item.minecraft.pumpkin_seeds": "Käverssäöte",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Vigelette Farve",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Rauhet Kanickel",
  "item.minecraft.rabbit_foot": "Haasenpoot",
  "item.minecraft.rabbit_hide": "Kanickelfell",
  "item.minecraft.rabbit_spawn_egg": "Kanickel-Spawn-Ai",
  "item.minecraft.rabbit_stew": "Kanickelragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Verwööster-Spawn-Ai",
  "item.minecraft.raw_copper": "Rauhkopper",
  "item.minecraft.raw_gold": "Rauhgüld",
  "item.minecraft.raw_iron": "Rauhisen",
  "item.minecraft.recovery_compass": "Wiederherstellungskompass",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Roote Farve",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone-Pulwer",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Vöruot Fleesk",
  "item.minecraft.saddle": "Saddel",
  "item.minecraft.salmon": "Rauher Las",
  "item.minecraft.salmon_bucket": "Lasemmer",
  "item.minecraft.salmon_spawn_egg": "Las-Spawn-Ai",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Hoornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Scheer",
  "item.minecraft.sheep_spawn_egg": "Schap-Spawn-Ai",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Swatter Schild",
  "item.minecraft.shield.blue": "Blaoer Schild",
  "item.minecraft.shield.brown": "Bruuner Schild",
  "item.minecraft.shield.cyan": "Blaogrööner Schild",
  "item.minecraft.shield.gray": "Graoer Schild",
  "item.minecraft.shield.green": "Grööner Schild",
  "item.minecraft.shield.light_blue": "Lechtblaoer Schild",
  "item.minecraft.shield.light_gray": "Grieser Schild",
  "item.minecraft.shield.lime": "Lechtgrööner Schild",
  "item.minecraft.shield.magenta": "Magenta Schild",
  "item.minecraft.shield.orange": "Geelrooter Schild",
  "item.minecraft.shield.pink": "Fienrooter Schild",
  "item.minecraft.shield.purple": "Vigeletter Schild",
  "item.minecraft.shield.red": "Rooter Schild",
  "item.minecraft.shield.white": "Witter Schild",
  "item.minecraft.shield.yellow": "Geeler Schild",
  "item.minecraft.shulker_shell": "Shulker-Schaal",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ai",
  "item.minecraft.sign": "Schild",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Sülwerfisken-Spawn-Ai",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeletpeerde-Spawn-Ai",
  "item.minecraft.skeleton_spawn_egg": "Skelet-Spawn-Ai",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Kopp",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Sliembal",
  "item.minecraft.slime_spawn_egg": "Sliem-Spawn-Ai",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüst",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Sneebal",
  "item.minecraft.spectral_arrow": "Spektraalpiel",
  "item.minecraft.spider_eye": "Spennauge",
  "item.minecraft.spider_spawn_egg": "Spenn-Spawn-Ai",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Smeetdrank",
  "item.minecraft.splash_potion.effect.awkward": "Raarer Smeetdrank",
  "item.minecraft.splash_potion.effect.empty": "Neet braubarer Smeetdrank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Smeetdrank de Förresistenz",
  "item.minecraft.splash_potion.effect.harming": "Smeetdrank de Schaas",
  "item.minecraft.splash_potion.effect.healing": "Smeetdrank de Betern",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Smeetdrank de Unsichtborkeid",
  "item.minecraft.splash_potion.effect.leaping": "Smeetdrank de Sprungkracht",
  "item.minecraft.splash_potion.effect.levitation": "Smeetdrank de Swevekracht",
  "item.minecraft.splash_potion.effect.luck": "Smeetdrank de Glük",
  "item.minecraft.splash_potion.effect.mundane": "Gewöhnelker Smeetdrank",
  "item.minecraft.splash_potion.effect.night_vision": "Smeetdrank de Nachtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Smeetdrank de Vergiften",
  "item.minecraft.splash_potion.effect.regeneration": "Smeetdrank de Regeneratioon",
  "item.minecraft.splash_potion.effect.slow_falling": "Smeetdrank de sachte Val",
  "item.minecraft.splash_potion.effect.slowness": "Smeetdrank de Langsaamkeid",
  "item.minecraft.splash_potion.effect.strength": "Smeetdrank de Starkte",
  "item.minecraft.splash_potion.effect.swiftness": "Smeetdrank de Gauigkait",
  "item.minecraft.splash_potion.effect.thick": "Lobberger Smeetdrank",
  "item.minecraft.splash_potion.effect.turtle_master": "Smeetdrank vun ’n Skildpadmeester",
  "item.minecraft.splash_potion.effect.water": "Smietbare Waterbuddel",
  "item.minecraft.splash_potion.effect.water_breathing": "Smeetdrank de Unnerwateratmung",
  "item.minecraft.splash_potion.effect.weakness": "Smeetdrank de Swackte",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Füchtenholtbööd",
  "item.minecraft.spruce_chest_boat": "Füchtenholtbööd met Truh",
  "item.minecraft.spyglass": "Kieker",
  "item.minecraft.squid_spawn_egg": "Enktfisk-Spawn-Ai",
  "item.minecraft.stick": "Stok",
  "item.minecraft.stone_axe": "Steenäkse",
  "item.minecraft.stone_hoe": "Steenhak",
  "item.minecraft.stone_pickaxe": "Steenbicke",
  "item.minecraft.stone_shovel": "Steenschöfel",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Steenswiärt",
  "item.minecraft.stray_spawn_egg": "Ieswander-Spawn-Ai",
  "item.minecraft.strider_spawn_egg": "Lawaloper-Spawn-Ai",
  "item.minecraft.string": "Snoer",
  "item.minecraft.sugar": "Sucker",
  "item.minecraft.suspicious_stew": "Seelsame Sopp",
  "item.minecraft.sweet_berries": "Söötbeje",
  "item.minecraft.tadpole_bucket": "Eimer Kaulquappe",
  "item.minecraft.tadpole_spawn_egg": "Kaulquappe Spawn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Drankt Piel",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Nich herstellig drankt Piel",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Piel de Förresistenz",
  "item.minecraft.tipped_arrow.effect.harming": "Piel de Schaas",
  "item.minecraft.tipped_arrow.effect.healing": "Piel de Betern",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Piel de Unsichtborkeid",
  "item.minecraft.tipped_arrow.effect.leaping": "Piel de Sprungkracht",
  "item.minecraft.tipped_arrow.effect.levitation": "Piel de Swevekracht",
  "item.minecraft.tipped_arrow.effect.luck": "Piel de Glük",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Piel de Nachtsicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Piel de Vergiften",
  "item.minecraft.tipped_arrow.effect.regeneration": "Piel de Regeneratioon",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Piel de sachte Val",
  "item.minecraft.tipped_arrow.effect.slowness": "Piel de Langsaamkeid",
  "item.minecraft.tipped_arrow.effect.strength": "Piel de Starkde",
  "item.minecraft.tipped_arrow.effect.swiftness": "Piel de Gauigkait",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Piel vun ’n Skildpadmeester",
  "item.minecraft.tipped_arrow.effect.water": "Natter Piel",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Piel de Unnerwateratmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Piel de Swackde",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "TNT-Kaor",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Totem van Unstarvigkeeit",
  "item.minecraft.trader_llama_spawn_egg": "Hannelsmannlama-Spawn-Ai",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Dreetack",
  "item.minecraft.tropical_fish": "Tropenfisk",
  "item.minecraft.tropical_fish_bucket": "Tropenfiskemmer",
  "item.minecraft.tropical_fish_spawn_egg": "Troopenfisk-Spawn-Ai",
  "item.minecraft.turtle_helmet": "Skildpadskild",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Skildpad-Spawn-Ai",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Plagegeester-Spawn-Ai",
  "item.minecraft.villager_spawn_egg": "Dörpsbewahner-Spawn-Ai",
  "item.minecraft.vindicator_spawn_egg": "Dener-Spawn-Ai",
  "item.minecraft.wandering_trader_spawn_egg": "Wannernde-Hannelsmann-Spawn-Ai",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Laichei des Wächters",
  "item.minecraft.warped_fungus_on_a_stick": "Wierpilzroot",
  "item.minecraft.water_bucket": "Wateremmer",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Waiten",
  "item.minecraft.wheat_seeds": "Waitenkoorns",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Witte Farve",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Hexen-Spawn-Ai",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelet-Spawn-Ai",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Wulf-Spawn-Ai",
  "item.minecraft.wooden_axe": "Holtäkse",
  "item.minecraft.wooden_hoe": "Holthak",
  "item.minecraft.wooden_pickaxe": "Holtbicke",
  "item.minecraft.wooden_shovel": "Holtschöfel",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Holtswiärt",
  "item.minecraft.writable_book": "Book un Fiäder",
  "item.minecraft.written_book": "Schriëwen Book",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Geele Farve",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ai",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepeerde-Spawn-Ai",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Ai",
  "item.minecraft.zombie_villager_spawn_egg": "Dörpsbewahnerzombie-Spawn-Ai",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifiierter-Piglin-Spawn-Ai"
}
export const nds_de = items; 
